/**
 * decodeBase64 decodes a base64 or base64url string.
 */ function $7b267e1bfb29ea44$var$decodeBase64(encoded) {
    return atob(encoded.replaceAll("-", "+").replaceAll("_", "/"));
}
function $7b267e1bfb29ea44$export$2ce5d8ddc341dca(handoverToken) {
    let userInitials = "";
    if (typeof handoverToken.name === "string") {
        // Remove double spaces, and spaces at the start or end.
        const cleanName = handoverToken.name.replace(/  +/g, " ").replace(/(^ )|( $)/g, "");
        const names = cleanName.split(" ");
        // Map each name to its upper-case first letter and join them to form the initials.
        userInitials = names.filter((name)=>name).map((name)=>name[0].toUpperCase()).join("");
    }
    if (!userInitials && typeof handoverToken.emails === "object" && handoverToken.emails.length) {
        const initialsFromEmail = (email)=>email.split("@")[0].split(".").filter((part)=>part).map((part)=>part[0].toUpperCase()).join("");
        const potentialInitials = handoverToken.emails.map(initialsFromEmail);
        // Try and find initials of length 2, then 1, then choose anything.
        userInitials = potentialInitials.filter((initial)=>initial.length === 2)[0] || potentialInitials.filter((initial)=>initial.length === 1)[0] || potentialInitials.filter((initial)=>initial.length)[0] || "";
    }
    let shortUserInitials = userInitials;
    if (shortUserInitials.length > 2) shortUserInitials = userInitials[0] + userInitials[userInitials.length - 1];
    return {
        userInitials: userInitials,
        shortUserInitials: shortUserInitials
    };
}
function $7b267e1bfb29ea44$export$a64b7dde781de219(token) {
    return $7b267e1bfb29ea44$export$d22a1357b4a7956(token, true, true);
}
function $7b267e1bfb29ea44$export$d22a1357b4a7956(token, parseUserInfo = true, includeParsedTokens = false) {
    // Parse optional data postfix
    let data;
    const dataIdx = token.indexOf(":");
    if (dataIdx > -1) {
        data = token.substr(dataIdx + 1);
        token = token.substr(0, dataIdx);
    }
    const parts = token.split(".");
    if ((parts.length !== 7 || parts[0] !== "0") && (parts.length !== 11 || parts[0] !== "1") && (parts.length !== 9 || parts[0] !== "2" && parts[0] !== "3") && (parts.length !== 8 || parts[0] !== "4" && parts[0] !== "5")) throw new Error(`invalid version ${parts.length && parts[0]} token of length ${parts.length}`);
    const serviceToken = JSON.parse($7b267e1bfb29ea44$var$decodeBase64(parts[5]));
    const result = {
        handoverToken: token,
        userToken: parts.slice(1, 4).join("."),
        serviceToken: parts.slice(4, 7).join("."),
        service: serviceToken["aud"],
        data: data
    };
    switch(result.service){
        case "test":
        case "analytics":
        case "integration-access-admin":
            result.domainId = serviceToken["mv-did"];
            result.organisationName = serviceToken["mv-org-name"];
            result.integrationSettingsId = parseInt(serviceToken["mv-isid"], 10);
            break;
        case "domain-selection":
            result.domainIds = serviceToken["mv-dids"].split("~");
            result.organisationNames = serviceToken["mv-org-names"].split("~");
            break;
        case "integration-selection":
            result.domainId = serviceToken["mv-did"];
            result.organisationName = serviceToken["mv-org-name"];
            result.integrationSettingsIds = serviceToken["mv-isids"].split("~").map((id)=>parseInt(id, 10));
            break;
        case "service-selection":
            result.domainId = serviceToken["mv-did"];
            result.organisationName = serviceToken["mv-org-name"];
            result.integrationSettingsId = parseInt(serviceToken["mv-isid"], 10);
            result.services = serviceToken["mv-svcs"].split("~");
            break;
    }
    if (includeParsedTokens) result.parsedServiceToken = serviceToken;
    if (parseUserInfo) {
        const userToken = JSON.parse($7b267e1bfb29ea44$var$decodeBase64(parts[2]));
        result.oid = userToken["oid"];
        result.name = userToken["name"];
        result.emails = userToken["emails"] || [];
        if (includeParsedTokens) result.parsedUserToken = userToken;
        const { userInitials: userInitials, shortUserInitials: shortUserInitials } = $7b267e1bfb29ea44$export$2ce5d8ddc341dca(result);
        result.userInitials = userInitials;
        result.shortUserInitials = shortUserInitials;
    }
    if (parts[0] === "1") {
        result.appToken = parts[7];
        result.refreshToken = parts.slice(8, 11).join(".");
    } else if (parts[0] === "2") {
        result.appToken = parts[7];
        result.refreshToken = $7b267e1bfb29ea44$var$decodeBase64(parts[8]);
    } else if (parts[0] === "3") {
        result.appToken = parts[7];
        result.refreshToken = parts[8];
    } else if (parts[0] === "4" || parts[0] === "5") result.refreshToken = parts[7];
    return result;
}
function $7b267e1bfb29ea44$export$4176c34dcd4299dc(tokenId) {
    return fetch("https://simple-store.mevitae.net/api/get", {
        method: "POST",
        headers: {
            "X-MeVitae-Key": "public-analytics"
        },
        body: tokenId,
        mode: "cors",
        cache: "no-store",
        redirect: "error"
    }).then((resp)=>{
        if (resp.status === 404) return null;
        if (resp.status !== 200) throw new Error("Simple store status was not 200");
        return resp.text();
    });
}
function $7b267e1bfb29ea44$export$afab66673263fb28(tokenId, parseUserInfo = true, includeParsedTokens = false) {
    return $7b267e1bfb29ea44$export$4176c34dcd4299dc(tokenId).then((token)=>typeof token === "string" && $7b267e1bfb29ea44$export$d22a1357b4a7956(token, parseUserInfo, includeParsedTokens) || null);
}
function $7b267e1bfb29ea44$export$dbe2080fb454fd3b(userToken, serviceToken, refreshToken, parseUserInfo = true, includeParsedTokens = false, storeNewToken = true) {
    return $7b267e1bfb29ea44$export$9c0fa3d0f5130863(userToken, serviceToken, refreshToken).then((token)=>{
        if (typeof token !== "string") return null;
        if (storeNewToken) localStorage.setItem("handoverToken", token);
        return $7b267e1bfb29ea44$export$d22a1357b4a7956(token, parseUserInfo, includeParsedTokens);
    });
}
function $7b267e1bfb29ea44$export$9c0fa3d0f5130863(userToken, serviceToken, refreshToken) {
    const body = new FormData();
    body.append("accessToken", userToken);
    body.append("serviceToken", serviceToken);
    body.append("refreshToken", refreshToken);
    return fetch("https://accounts.mevitae.com/refresh", {
        method: "POST",
        body: body,
        mode: "cors",
        cache: "no-store",
        redirect: "error"
    }).then((resp)=>{
        if (resp.status !== 200) throw new Error("Refresh status was not 200");
        return resp.text();
    });
}
function $7b267e1bfb29ea44$export$a7fe16ffd34a2ac3(search) {
    if (!search) search = location.search;
    const args = {};
    if (search.length > 0) {
        // Remove the initial '?' if present.
        if (search[0] === "?") search = search.substring(1);
        // Parse each argument
        search.split("&").forEach((arg)=>{
            // The argument value defaults to an empty string...
            let value = "";
            // Unless specified...
            const eq = arg.indexOf("=");
            if (eq > 0) {
                value = arg.substring(eq + 1);
                arg = arg.substring(0, eq);
            }
            // Both the name and value get decoded.
            args[decodeURIComponent(arg)] = decodeURIComponent(value);
        });
    }
    return args;
}
function $7b267e1bfb29ea44$export$68de14ea746132ad(args) {
    let search = "";
    for(const arg in args){
        if (search.length === 0) search += "?";
        else search += "&";
        search += arg + "=" + encodeURIComponent(args[arg]);
    }
    return search;
}
function $7b267e1bfb29ea44$export$a92a231fc755c6bb(search, removeFromQuery = true) {
    const args = $7b267e1bfb29ea44$export$a7fe16ffd34a2ac3(search);
    const { tokenId: tokenId } = args;
    console.log("Token ID:", tokenId);
    if (!tokenId) return {
        search: args,
        tokenId: null
    };
    delete args.tokenId;
    if (removeFromQuery) window.history.replaceState(null, // @ts-ignore
    null, $7b267e1bfb29ea44$export$68de14ea746132ad(args) || "?");
    return {
        search: args,
        tokenId: tokenId
    };
}
function $7b267e1bfb29ea44$export$f0b24abea1fca6a9() {
    localStorage.removeItem("handoverToken");
}
async function $7b267e1bfb29ea44$export$86e57292095ec11() {
    const { tokenId: tokenId, search: search } = $7b267e1bfb29ea44$export$a92a231fc755c6bb();
    let handoverToken;
    if (!tokenId) // If we don't have a new token ID, get the token from storage.
    handoverToken = localStorage.getItem("handoverToken");
    else {
        // If we do have a new token ID, fetch the new token
        handoverToken = await $7b267e1bfb29ea44$export$4176c34dcd4299dc(tokenId);
        // Update the stored handover token
        if (handoverToken) localStorage.setItem("handoverToken", handoverToken);
        else localStorage.removeItem("handoverToken");
    }
    if (!handoverToken) return {
        search: search,
        handoverToken: null
    };
    return {
        search: search,
        handoverToken: $7b267e1bfb29ea44$export$a64b7dde781de219(handoverToken)
    };
}
function $7b267e1bfb29ea44$export$13027c5f6f75959e(search, parseUserInfo = true, includeParsedTokens = false, removeFromQuery = true) {
    const { search: args, tokenId: tokenId } = $7b267e1bfb29ea44$export$a92a231fc755c6bb(search, removeFromQuery);
    if (!tokenId) return Promise.resolve({
        search: args,
        handoverToken: null
    });
    return $7b267e1bfb29ea44$export$afab66673263fb28(tokenId, parseUserInfo, includeParsedTokens).then((handoverToken)=>({
            handoverToken: handoverToken,
            search: args
        }));
}


class $3aec7978884109a4$export$da90a2a087380114 {
    constructor(generate){
        this.authWrapper = null;
        this.generate = generate;
        this.fetch = this.fetch.bind(this);
        this.token = this.token.bind(this);
        this.logout = this.logout.bind(this);
    }
    static fromSession(navigateToLogin) {
        return new $3aec7978884109a4$export$da90a2a087380114(()=>$3aec7978884109a4$export$5256615b306d8eda.fromSession(navigateToLogin));
    }
    asyncAuthWrapper() {
        if (!this.authWrapper) this.authWrapper = this.generate();
        return this.authWrapper;
    }
    fetch(url, options = {}, retries = 1, timeout = 90000) {
        return this.asyncAuthWrapper().fetch(url, options, retries, timeout);
    }
    token() {
        return this.asyncAuthWrapper().token();
    }
    logout() {
        return this.asyncAuthWrapper().logout();
    }
}
class $3aec7978884109a4$export$9c62fd22e3e5a51c {
    #authWrapper;
    constructor(navigateToLogin){
        this.#authWrapper = null;
        this.navigateToLogin = navigateToLogin;
    }
    static fromSession(navigateToLogin) {
        return new $3aec7978884109a4$export$9c62fd22e3e5a51c(navigateToLogin);
    }
    authWrapper() {
        if (!this.#authWrapper) this.#authWrapper = $3aec7978884109a4$export$9b8f089fab3cf7ba.tryFromSession(this.navigateToLogin);
        return this.#authWrapper;
    }
    async mustAuthWrapper() {
        const authWrapper = await this.authWrapper();
        if (authWrapper) return authWrapper;
        this.navigateToLogin();
        throw new Error("navigateToLogin should not return!");
    }
    mustAsyncAuthWrapper() {
        return new $3aec7978884109a4$export$5256615b306d8eda(this.mustAuthWrapper());
    }
}
class $3aec7978884109a4$export$5256615b306d8eda {
    constructor(authFetchPromise){
        this.authWrapperPromise = authFetchPromise;
        this.fetch = this.fetch.bind(this);
        this.token = this.token.bind(this);
        this.logout = this.logout.bind(this);
    }
    static fromSession(navigateToLogin) {
        return new $3aec7978884109a4$export$5256615b306d8eda($3aec7978884109a4$export$9b8f089fab3cf7ba.fromSession(navigateToLogin));
    }
    async fetch(url, options = {}, retries = 1, timeout = 90000) {
        const wrapper = await this.authWrapperPromise;
        return wrapper.fetch(url, options, retries, timeout);
    }
    async token() {
        const wrapper = await this.authWrapperPromise;
        return wrapper.token;
    }
    async logout() {
        const wrapper = await this.authWrapperPromise;
        return wrapper.logout();
    }
}
class $3aec7978884109a4$export$9b8f089fab3cf7ba {
    /**
     * If there's currently a refresh occurring, a promise resolving when it's complete.
     *
     * This is used to prevent multiple simultaneous refreshes, one of which must fail, since a
     * refresh token only works once.
     */ #refresh;
    constructor(token, navigateToLogin){
        this.token = token;
        this.navigateToLogin = navigateToLogin;
        this.#refresh = null;
        this.fetch = this.fetch.bind(this);
    }
    logout() {
        (0, $7b267e1bfb29ea44$export$f0b24abea1fca6a9)();
        this.navigateToLogin();
    }
    static async tryFromSession(navigateToLogin) {
        // First, try to load a new token from the search query
        const { handoverToken: handoverToken } = await (0, $7b267e1bfb29ea44$export$86e57292095ec11)();
        if (handoverToken) return new $3aec7978884109a4$export$9b8f089fab3cf7ba(handoverToken, navigateToLogin);
        return null;
    }
    static async fromSession(navigateToLogin) {
        const wrapper = await $3aec7978884109a4$export$9b8f089fab3cf7ba.tryFromSession(navigateToLogin);
        if (wrapper) return wrapper;
        // If there's no auth, navigate to the login page!
        navigateToLogin();
        throw new Error("navigateToLogin should not return!");
    }
    /**
     * Refresh the token, and resolve when refreshed.
     */ refreshToken() {
        // If there's already a refresh in progress, there's no need to start another one.
        // In fact, starting another one would cause one refresh to fail, since the refresh token
        // can only be used once.
        if (!this.#refresh) {
            // Except if there's not a refresh token, we can't actually do a refresh...
            if (!this.token.refreshToken) return Promise.resolve();
            this.#refresh = (0, $7b267e1bfb29ea44$export$dbe2080fb454fd3b)(this.token.userToken, this.token.serviceToken, this.token.refreshToken, true, true).then((token)=>{
                if (!token) // Logout if the refresh failed.
                this.logout();
                else {
                    // Otherwise, store the new token, and clear the current refresh.
                    // @ts-ignore
                    this.token = token;
                    this.#refresh = null;
                }
            }).catch((err)=>{
                console.log("Failed to refresh token:");
                console.error(err);
                this.navigateToLogin();
            });
        }
        return this.#refresh;
    }
    fetch(url, options = {}, retries = 1, timeout = 90000, refresh = true) {
        if (!options) options = {};
        const controller = new AbortController();
        const timeoutId = setTimeout(()=>controller.abort(), timeout);
        options.signal = controller.signal;
        // Set authorization tokens
        if (!options.headers) options.headers = {};
        // @ts-ignore
        options.headers["Authorization"] = "Bearer " + this.token.userToken;
        // @ts-ignore
        options.headers["X-MeVitae-Service-Token"] = this.token.serviceToken;
        return fetch(url, options).then((res)=>{
            clearTimeout(timeoutId);
            if (res.status === 401 || res.status === 403) {
                if (refresh && this.token.refreshToken) return this.refreshToken().then(()=>this.fetch(url, options, retries - 1, timeout, false));
                this.logout();
            } else if (!res.ok && retries > 0) return this.fetch(url, options, retries - 1, timeout, refresh);
            return res;
        });
    }
}



var $dfbca3f0ad245625$exports = {};
// https://github.com/farzher/fuzzysort v2.0.4
/*
  SublimeText-like Fuzzy Search

  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', [{file:'Monitor.cpp'}, {file:'MeshRenderer.cpp'}], {key:'file'})
  // [{score:-18, obj:{file:'MeshRenderer.cpp'}}, {score:-6009, obj:{file:'Monitor.cpp'}}]

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/ // UMD (Universal Module Definition) for fuzzysort
((root, UMD)=>{
    if (typeof define === "function" && define.amd) define([], UMD);
    else if (0, $dfbca3f0ad245625$exports) $dfbca3f0ad245625$exports = UMD();
    else root["fuzzysort"] = UMD();
})($dfbca3f0ad245625$exports, (_)=>{
    "use strict";
    var single = (search, target)=>{
        if (search == "farzher") return {
            target: "farzher was here (^-^*)/",
            score: 0,
            _indexes: [
                0
            ]
        };
        if (!search || !target) return NULL;
        var preparedSearch = getPreparedSearch(search);
        if (!isObj(target)) target = getPrepared(target);
        var searchBitflags = preparedSearch.bitflags;
        if ((searchBitflags & target._bitflags) !== searchBitflags) return NULL;
        return algorithm(preparedSearch, target);
    };
    var go = (search, targets, options)=>{
        if (search == "farzher") return [
            {
                target: "farzher was here (^-^*)/",
                score: 0,
                _indexes: [
                    0
                ],
                obj: targets ? targets[0] : NULL
            }
        ];
        if (!search) return options && options.all ? all(search, targets, options) : noResults;
        var preparedSearch = getPreparedSearch(search);
        var searchBitflags = preparedSearch.bitflags;
        var containsSpace = preparedSearch.containsSpace;
        var threshold = options && options.threshold || INT_MIN;
        var limit = options && options["limit"] || INT_MAX // for some reason only limit breaks when minified
        ;
        var resultsLen = 0;
        var limitedCount = 0;
        var targetsLen = targets.length;
        // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]
        // options.key
        if (options && options.key) {
            var key = options.key;
            for(var i = 0; i < targetsLen; ++i){
                var obj = targets[i];
                var target = getValue(obj, key);
                if (!target) continue;
                if (!isObj(target)) target = getPrepared(target);
                if ((searchBitflags & target._bitflags) !== searchBitflags) continue;
                var result = algorithm(preparedSearch, target);
                if (result === NULL) continue;
                if (result.score < threshold) continue;
                // have to clone result so duplicate targets from different obj can each reference the correct obj
                result = {
                    target: result.target,
                    _targetLower: "",
                    _targetLowerCodes: NULL,
                    _nextBeginningIndexes: NULL,
                    _bitflags: 0,
                    score: result.score,
                    _indexes: result._indexes,
                    obj: obj
                } // hidden
                ;
                if (resultsLen < limit) {
                    q.add(result);
                    ++resultsLen;
                } else {
                    ++limitedCount;
                    if (result.score > q.peek().score) q.replaceTop(result);
                }
            }
        // options.keys
        } else if (options && options.keys) {
            var scoreFn = options["scoreFn"] || defaultScoreFn;
            var keys = options.keys;
            var keysLen = keys.length;
            for(var i = 0; i < targetsLen; ++i){
                var obj = targets[i];
                var objResults = new Array(keysLen);
                for(var keyI = 0; keyI < keysLen; ++keyI){
                    var key = keys[keyI];
                    var target = getValue(obj, key);
                    if (!target) {
                        objResults[keyI] = NULL;
                        continue;
                    }
                    if (!isObj(target)) target = getPrepared(target);
                    if ((searchBitflags & target._bitflags) !== searchBitflags) objResults[keyI] = NULL;
                    else objResults[keyI] = algorithm(preparedSearch, target);
                }
                objResults.obj = obj // before scoreFn so scoreFn can use it
                ;
                var score = scoreFn(objResults);
                if (score === NULL) continue;
                if (score < threshold) continue;
                objResults.score = score;
                if (resultsLen < limit) {
                    q.add(objResults);
                    ++resultsLen;
                } else {
                    ++limitedCount;
                    if (score > q.peek().score) q.replaceTop(objResults);
                }
            }
        // no keys
        } else for(var i = 0; i < targetsLen; ++i){
            var target = targets[i];
            if (!target) continue;
            if (!isObj(target)) target = getPrepared(target);
            if ((searchBitflags & target._bitflags) !== searchBitflags) continue;
            var result = algorithm(preparedSearch, target);
            if (result === NULL) continue;
            if (result.score < threshold) continue;
            if (resultsLen < limit) {
                q.add(result);
                ++resultsLen;
            } else {
                ++limitedCount;
                if (result.score > q.peek().score) q.replaceTop(result);
            }
        }
        if (resultsLen === 0) return noResults;
        var results = new Array(resultsLen);
        for(var i = resultsLen - 1; i >= 0; --i)results[i] = q.poll();
        results.total = resultsLen + limitedCount;
        return results;
    };
    var highlight = (result, hOpen, hClose)=>{
        if (typeof hOpen === "function") return highlightCallback(result, hOpen);
        if (result === NULL) return NULL;
        if (hOpen === undefined) hOpen = "<b>";
        if (hClose === undefined) hClose = "</b>";
        var highlighted = "";
        var matchesIndex = 0;
        var opened = false;
        var target = result.target;
        var targetLen = target.length;
        var indexes = result._indexes;
        indexes = indexes.slice(0, indexes.len).sort((a, b)=>a - b);
        for(var i = 0; i < targetLen; ++i){
            var char = target[i];
            if (indexes[matchesIndex] === i) {
                ++matchesIndex;
                if (!opened) {
                    opened = true;
                    highlighted += hOpen;
                }
                if (matchesIndex === indexes.length) {
                    highlighted += char + hClose + target.substr(i + 1);
                    break;
                }
            } else if (opened) {
                opened = false;
                highlighted += hClose;
            }
            highlighted += char;
        }
        return highlighted;
    };
    var highlightCallback = (result, cb)=>{
        if (result === NULL) return NULL;
        var target = result.target;
        var targetLen = target.length;
        var indexes = result._indexes;
        indexes = indexes.slice(0, indexes.len).sort((a, b)=>a - b);
        var highlighted = "";
        var matchI = 0;
        var indexesI = 0;
        var opened = false;
        var result = [];
        for(var i = 0; i < targetLen; ++i){
            var char = target[i];
            if (indexes[indexesI] === i) {
                ++indexesI;
                if (!opened) {
                    opened = true;
                    result.push(highlighted);
                    highlighted = "";
                }
                if (indexesI === indexes.length) {
                    highlighted += char;
                    result.push(cb(highlighted, matchI++));
                    highlighted = "";
                    result.push(target.substr(i + 1));
                    break;
                }
            } else if (opened) {
                opened = false;
                result.push(cb(highlighted, matchI++));
                highlighted = "";
            }
            highlighted += char;
        }
        return result;
    };
    var indexes = (result)=>result._indexes.slice(0, result._indexes.len).sort((a, b)=>a - b);
    var prepare = (target)=>{
        if (typeof target !== "string") target = "";
        var info = prepareLowerInfo(target);
        return {
            "target": target,
            _targetLower: info._lower,
            _targetLowerCodes: info.lowerCodes,
            _nextBeginningIndexes: NULL,
            _bitflags: info.bitflags,
            "score": NULL,
            _indexes: [
                0
            ],
            "obj": NULL
        } // hidden
        ;
    };
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    var prepareSearch = (search)=>{
        if (typeof search !== "string") search = "";
        search = search.trim();
        var info = prepareLowerInfo(search);
        var spaceSearches = [];
        if (info.containsSpace) {
            var searches = search.split(/\s+/);
            searches = [
                ...new Set(searches)
            ] // distinct
            ;
            for(var i = 0; i < searches.length; i++){
                if (searches[i] === "") continue;
                var _info = prepareLowerInfo(searches[i]);
                spaceSearches.push({
                    lowerCodes: _info.lowerCodes,
                    _lower: searches[i].toLowerCase(),
                    containsSpace: false
                });
            }
        }
        return {
            lowerCodes: info.lowerCodes,
            bitflags: info.bitflags,
            containsSpace: info.containsSpace,
            _lower: info._lower,
            spaceSearches: spaceSearches
        };
    };
    var getPrepared = (target)=>{
        if (target.length > 999) return prepare(target) // don't cache huge targets
        ;
        var targetPrepared = preparedCache.get(target);
        if (targetPrepared !== undefined) return targetPrepared;
        targetPrepared = prepare(target);
        preparedCache.set(target, targetPrepared);
        return targetPrepared;
    };
    var getPreparedSearch = (search)=>{
        if (search.length > 999) return prepareSearch(search) // don't cache huge searches
        ;
        var searchPrepared = preparedSearchCache.get(search);
        if (searchPrepared !== undefined) return searchPrepared;
        searchPrepared = prepareSearch(search);
        preparedSearchCache.set(search, searchPrepared);
        return searchPrepared;
    };
    var all = (search, targets, options)=>{
        var results = [];
        results.total = targets.length;
        var limit = options && options.limit || INT_MAX;
        if (options && options.key) for(var i = 0; i < targets.length; i++){
            var obj = targets[i];
            var target = getValue(obj, options.key);
            if (!target) continue;
            if (!isObj(target)) target = getPrepared(target);
            target.score = INT_MIN;
            target._indexes.len = 0;
            var result = target;
            result = {
                target: result.target,
                _targetLower: "",
                _targetLowerCodes: NULL,
                _nextBeginningIndexes: NULL,
                _bitflags: 0,
                score: target.score,
                _indexes: NULL,
                obj: obj
            } // hidden
            ;
            results.push(result);
            if (results.length >= limit) return results;
        }
        else if (options && options.keys) for(var i = 0; i < targets.length; i++){
            var obj = targets[i];
            var objResults = new Array(options.keys.length);
            for(var keyI = options.keys.length - 1; keyI >= 0; --keyI){
                var target = getValue(obj, options.keys[keyI]);
                if (!target) {
                    objResults[keyI] = NULL;
                    continue;
                }
                if (!isObj(target)) target = getPrepared(target);
                target.score = INT_MIN;
                target._indexes.len = 0;
                objResults[keyI] = target;
            }
            objResults.obj = obj;
            objResults.score = INT_MIN;
            results.push(objResults);
            if (results.length >= limit) return results;
        }
        else for(var i = 0; i < targets.length; i++){
            var target = targets[i];
            if (!target) continue;
            if (!isObj(target)) target = getPrepared(target);
            target.score = INT_MIN;
            target._indexes.len = 0;
            results.push(target);
            if (results.length >= limit) return results;
        }
        return results;
    };
    var algorithm = (preparedSearch, prepared, allowSpaces = false)=>{
        if (allowSpaces === false && preparedSearch.containsSpace) return algorithmSpaces(preparedSearch, prepared);
        var searchLower = preparedSearch._lower;
        var searchLowerCodes = preparedSearch.lowerCodes;
        var searchLowerCode = searchLowerCodes[0];
        var targetLowerCodes = prepared._targetLowerCodes;
        var searchLen = searchLowerCodes.length;
        var targetLen = targetLowerCodes.length;
        var searchI = 0 // where we at
        ;
        var targetI = 0 // where you at
        ;
        var matchesSimpleLen = 0;
        // very basic fuzzy match; to remove non-matching targets ASAP!
        // walk through target. find sequential matches.
        // if all chars aren't found then exit
        for(;;){
            var isMatch = searchLowerCode === targetLowerCodes[targetI];
            if (isMatch) {
                matchesSimple[matchesSimpleLen++] = targetI;
                ++searchI;
                if (searchI === searchLen) break;
                searchLowerCode = searchLowerCodes[searchI];
            }
            ++targetI;
            if (targetI >= targetLen) return NULL // Failed to find searchI
            ;
        }
        var searchI = 0;
        var successStrict = false;
        var matchesStrictLen = 0;
        var nextBeginningIndexes = prepared._nextBeginningIndexes;
        if (nextBeginningIndexes === NULL) nextBeginningIndexes = prepared._nextBeginningIndexes = prepareNextBeginningIndexes(prepared.target);
        var firstPossibleI = targetI = matchesSimple[0] === 0 ? 0 : nextBeginningIndexes[matchesSimple[0] - 1];
        // Our target string successfully matched all characters in sequence!
        // Let's try a more advanced and strict test to improve the score
        // only count it as a match if it's consecutive or a beginning character!
        var backtrackCount = 0;
        if (targetI !== targetLen) for(;;)if (targetI >= targetLen) {
            // We failed to find a good spot for this search char, go back to the previous search char and force it forward
            if (searchI <= 0) break; // We failed to push chars forward for a better match
            ++backtrackCount;
            if (backtrackCount > 200) break; // exponential backtracking is taking too long, just give up and return a bad match
            --searchI;
            var lastMatch = matchesStrict[--matchesStrictLen];
            targetI = nextBeginningIndexes[lastMatch];
        } else {
            var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI];
            if (isMatch) {
                matchesStrict[matchesStrictLen++] = targetI;
                ++searchI;
                if (searchI === searchLen) {
                    successStrict = true;
                    break;
                }
                ++targetI;
            } else targetI = nextBeginningIndexes[targetI];
        }
        // check if it's a substring match
        var substringIndex = prepared._targetLower.indexOf(searchLower, matchesSimple[0]) // perf: this is slow
        ;
        var isSubstring = ~substringIndex;
        if (isSubstring && !successStrict) for(var i = 0; i < matchesSimpleLen; ++i)matchesSimple[i] = substringIndex + i;
        var isSubstringBeginning = false;
        if (isSubstring) isSubstringBeginning = prepared._nextBeginningIndexes[substringIndex - 1] === substringIndex;
        if (successStrict) {
            var matchesBest = matchesStrict;
            var matchesBestLen = matchesStrictLen;
        } else {
            var matchesBest = matchesSimple;
            var matchesBestLen = matchesSimpleLen;
        }
        var score = 0;
        var extraMatchGroupCount = 0;
        for(var i = 1; i < searchLen; ++i)if (matchesBest[i] - matchesBest[i - 1] !== 1) {
            score -= matchesBest[i];
            ++extraMatchGroupCount;
        }
        var unmatchedDistance = matchesBest[searchLen - 1] - matchesBest[0] - (searchLen - 1);
        score -= (12 + unmatchedDistance) * extraMatchGroupCount // penality for more groups
        ;
        if (matchesBest[0] !== 0) score -= matchesBest[0] * matchesBest[0] * .2 // penality for not starting near the beginning
        ;
        if (!successStrict) score *= 1000;
        else {
            // successStrict on a target with too many beginning indexes loses points for being a bad target
            var uniqueBeginningIndexes = 1;
            for(var i = nextBeginningIndexes[0]; i < targetLen; i = nextBeginningIndexes[i])++uniqueBeginningIndexes;
            if (uniqueBeginningIndexes > 24) score *= (uniqueBeginningIndexes - 24) * 10 // quite arbitrary numbers here ...
            ;
        }
        if (isSubstring) score /= 1 + searchLen * searchLen * 1 // bonus for being a full substring
        ;
        if (isSubstringBeginning) score /= 1 + searchLen * searchLen * 1 // bonus for substring starting on a beginningIndex
        ;
        score -= targetLen - searchLen // penality for longer targets
        ;
        prepared.score = score;
        for(var i = 0; i < matchesBestLen; ++i)prepared._indexes[i] = matchesBest[i];
        prepared._indexes.len = matchesBestLen;
        return prepared;
    };
    var algorithmSpaces = (preparedSearch, target)=>{
        var seen_indexes = new Set();
        var score = 0;
        var result = NULL;
        var first_seen_index_last_search = 0;
        var searches = preparedSearch.spaceSearches;
        for(var i = 0; i < searches.length; ++i){
            var search = searches[i];
            result = algorithm(search, target);
            if (result === NULL) return NULL;
            score += result.score;
            // dock points based on order otherwise "c man" returns Manifest.cpp instead of CheatManager.h
            if (result._indexes[0] < first_seen_index_last_search) score -= first_seen_index_last_search - result._indexes[0];
            first_seen_index_last_search = result._indexes[0];
            for(var j = 0; j < result._indexes.len; ++j)seen_indexes.add(result._indexes[j]);
        }
        // allows a search with spaces that's an exact substring to score well
        var allowSpacesResult = algorithm(preparedSearch, target, /*allowSpaces=*/ true);
        if (allowSpacesResult !== NULL && allowSpacesResult.score > score) return allowSpacesResult;
        result.score = score;
        var i = 0;
        for (let index of seen_indexes)result._indexes[i++] = index;
        result._indexes.len = i;
        return result;
    };
    var prepareLowerInfo = (str)=>{
        var strLen = str.length;
        var lower = str.toLowerCase();
        var lowerCodes = [] // new Array(strLen)    sparse array is too slow
        ;
        var bitflags = 0;
        var containsSpace = false // space isn't stored in bitflags because of how searching with a space works
        ;
        for(var i = 0; i < strLen; ++i){
            var lowerCode = lowerCodes[i] = lower.charCodeAt(i);
            if (lowerCode === 32) {
                containsSpace = true;
                continue; // it's important that we don't set any bitflags for space
            }
            var bit = lowerCode >= 97 && lowerCode <= 122 ? lowerCode - 97 // alphabet
             : lowerCode >= 48 && lowerCode <= 57 ? 26 // numbers
             : lowerCode <= 127 ? 30 // other ascii
             : 31 // other utf8
            ;
            bitflags |= 1 << bit;
        }
        return {
            lowerCodes: lowerCodes,
            bitflags: bitflags,
            containsSpace: containsSpace,
            _lower: lower
        };
    };
    var prepareBeginningIndexes = (target)=>{
        var targetLen = target.length;
        var beginningIndexes = [];
        var beginningIndexesLen = 0;
        var wasUpper = false;
        var wasAlphanum = false;
        for(var i = 0; i < targetLen; ++i){
            var targetCode = target.charCodeAt(i);
            var isUpper = targetCode >= 65 && targetCode <= 90;
            var isAlphanum = isUpper || targetCode >= 97 && targetCode <= 122 || targetCode >= 48 && targetCode <= 57;
            var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum;
            wasUpper = isUpper;
            wasAlphanum = isAlphanum;
            if (isBeginning) beginningIndexes[beginningIndexesLen++] = i;
        }
        return beginningIndexes;
    };
    var prepareNextBeginningIndexes = (target)=>{
        var targetLen = target.length;
        var beginningIndexes = prepareBeginningIndexes(target);
        var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
        ;
        var lastIsBeginning = beginningIndexes[0];
        var lastIsBeginningI = 0;
        for(var i = 0; i < targetLen; ++i)if (lastIsBeginning > i) nextBeginningIndexes[i] = lastIsBeginning;
        else {
            lastIsBeginning = beginningIndexes[++lastIsBeginningI];
            nextBeginningIndexes[i] = lastIsBeginning === undefined ? targetLen : lastIsBeginning;
        }
        return nextBeginningIndexes;
    };
    var cleanup = ()=>{
        preparedCache.clear();
        preparedSearchCache.clear();
        matchesSimple = [];
        matchesStrict = [];
    };
    var preparedCache = new Map();
    var preparedSearchCache = new Map();
    var matchesSimple = [];
    var matchesStrict = [];
    // for use with keys. just returns the maximum score
    var defaultScoreFn = (a)=>{
        var max = INT_MIN;
        var len = a.length;
        for(var i = 0; i < len; ++i){
            var result = a[i];
            if (result === NULL) continue;
            var score = result.score;
            if (score > max) max = score;
        }
        if (max === INT_MIN) return NULL;
        return max;
    };
    // prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
    // prop = 'key1.key2'        10ms
    // prop = ['key1', 'key2']   27ms
    var getValue = (obj, prop)=>{
        var tmp = obj[prop];
        if (tmp !== undefined) return tmp;
        var segs = prop;
        if (!Array.isArray(prop)) segs = prop.split(".");
        var len = segs.length;
        var i = -1;
        while(obj && ++i < len)obj = obj[segs[i]];
        return obj;
    };
    var isObj = (x)=>{
        return typeof x === "object";
    } // faster as a function
    ;
    // var INT_MAX = 9007199254740991; var INT_MIN = -INT_MAX
    var INT_MAX = Infinity;
    var INT_MIN = -INT_MAX;
    var noResults = [];
    noResults.total = 0;
    var NULL = null;
    // Hacked version of https://github.com/lemire/FastPriorityQueue.js
    var fastpriorityqueue = (r)=>{
        var e = [], o = 0, a = {}, v = (r)=>{
            for(var a = 0, v = e[a], c = 1; c < o;){
                var s = c + 1;
                a = c, s < o && e[s].score < e[c].score && (a = s), e[a - 1 >> 1] = e[a], c = 1 + (a << 1);
            }
            for(var f = a - 1 >> 1; a > 0 && v.score < e[f].score; f = (a = f) - 1 >> 1)e[a] = e[f];
            e[a] = v;
        };
        return a.add = (r)=>{
            var a = o;
            e[o++] = r;
            for(var v = a - 1 >> 1; a > 0 && r.score < e[v].score; v = (a = v) - 1 >> 1)e[a] = e[v];
            e[a] = r;
        }, a.poll = (r)=>{
            if (0 !== o) {
                var a = e[0];
                return e[0] = e[--o], v(), a;
            }
        }, a.peek = (r)=>{
            if (0 !== o) return e[0];
        }, a.replaceTop = (r)=>{
            e[0] = r, v();
        }, a;
    };
    var q = fastpriorityqueue() // reuse this
    ;
    // fuzzysort is written this way for minification. all names are mangeled unless quoted
    return {
        "single": single,
        "go": go,
        "highlight": highlight,
        "prepare": prepare,
        "indexes": indexes,
        "cleanup": cleanup
    };
}) // UMD
 // TODO: (feature) frecency
 // TODO: (perf) use different sorting algo depending on the # of results?
 // TODO: (perf) preparedCache is a memory leak
 // TODO: (like sublime) backslash === forwardslash
 // TODO: (perf) prepareSearch seems slow
;


class $60bfd8aa86a84fba$export$6955bcca4cd3539f {
    constructor(scale, top, height, boxes, bitmap){
        this.scale = scale;
        this.top = top;
        this.height = height;
        this.boxes = boxes;
        this.bitmap = bitmap;
    }
    draw(ctx, boxes = true) {
        ctx.drawImage(this.bitmap, 0, this.top);
        if (boxes) this.boxes.forEach((box)=>box.draw(ctx, this.top));
    }
    takeBox(x, y) {
        //if (y < this.top || this.top + this.height < y) return null;
        for(let idx = 0; idx < this.boxes.length; idx++){
            if (this.boxes[idx].contains(this.top, x, y)) return this.boxes.splice(idx, 1)[0];
        }
        return null;
    }
    addBox(box) {
        this.boxes.push(box);
    }
}


const $a3516c1494a0c6de$var$DEFAULT_RESIZE_BOX_RADIUS = 13;
const $a3516c1494a0c6de$var$DELETE_SIZE = 35;
class $a3516c1494a0c6de$export$e71c4d32a2263218 {
    constructor(bounds, color){
        this.bounds = bounds;
        this.color = color;
        const img = new Image();
        img.onload = ()=>{
            this.binImage = img;
        };
        img.src = "trash-button.svg";
    }
    contains(offsetY, x, y, padding = 0) {
        return offsetY + this.bounds.top - padding <= y && y <= offsetY + this.bounds.bottom + padding && this.bounds.left - padding <= x && x <= this.bounds.right + padding;
    }
    draw(ctx, yOffset, color = null, editor = false, selectedSide = -1) {
        ctx.fillStyle = color || this.color;
        ctx.fillRect(this.bounds.left - 2, yOffset + this.bounds.top - 2, this.bounds.right - this.bounds.left + 4, this.bounds.bottom - this.bounds.top + 4);
        if (editor) this.drawEditor(ctx, yOffset, selectedSide);
    }
    deleteCoords() {
        return {
            left: (this.bounds.left + this.bounds.right) / 2 - $a3516c1494a0c6de$var$DELETE_SIZE / 2,
            top: this.bounds.bottom + $a3516c1494a0c6de$var$DEFAULT_RESIZE_BOX_RADIUS + $a3516c1494a0c6de$var$DELETE_SIZE / 4
        };
    }
    drawEditor(ctx, yOffset, selectedSide, color = "#2A1A46", selectedColor = "#150A23") {
        const radius = $a3516c1494a0c6de$var$DEFAULT_RESIZE_BOX_RADIUS;
        // Left adjust
        ctx.fillStyle = selectedSide === 0 ? selectedColor : color;
        ctx.fillRect(this.bounds.left - radius + 1, yOffset + (this.bounds.top + this.bounds.bottom) / 2 - radius / 2, radius, radius);
        // Right adjust
        ctx.fillStyle = selectedSide === 1 ? selectedColor : color;
        ctx.fillRect(this.bounds.right - 1, yOffset + (this.bounds.top + this.bounds.bottom) / 2 - radius / 2, radius, radius);
        // Top adjust
        ctx.fillStyle = selectedSide === 2 ? selectedColor : color;
        ctx.fillRect((this.bounds.left + this.bounds.right) / 2 - radius / 2, yOffset + this.bounds.top - radius + 1, radius, radius);
        // Bottom adjust
        ctx.fillStyle = selectedSide === 3 ? selectedColor : color;
        ctx.fillRect((this.bounds.left + this.bounds.right) / 2 - radius / 2, yOffset + this.bounds.bottom - 1, radius, radius);
        // Delete button
        ctx.fillStyle = "#d00";
        const coords = this.deleteCoords();
        ctx.fillRect(coords.left, yOffset + coords.top, $a3516c1494a0c6de$var$DELETE_SIZE, $a3516c1494a0c6de$var$DELETE_SIZE);
        if (this.binImage) ctx.drawImage(this.binImage, coords.left + $a3516c1494a0c6de$var$DELETE_SIZE / 8, yOffset + coords.top + $a3516c1494a0c6de$var$DELETE_SIZE / 8, $a3516c1494a0c6de$var$DELETE_SIZE * 0.75, $a3516c1494a0c6de$var$DELETE_SIZE * 0.75);
    }
    isDelete(yOffset, x, y) {
        const coords = this.deleteCoords();
        return coords.left <= x && x <= coords.left + $a3516c1494a0c6de$var$DELETE_SIZE && yOffset + coords.top <= y && y <= yOffset + coords.top + $a3516c1494a0c6de$var$DELETE_SIZE;
    }
    selectedSide(yOffset, x, y, radius = $a3516c1494a0c6de$var$DEFAULT_RESIZE_BOX_RADIUS, largeRadius = $a3516c1494a0c6de$var$DEFAULT_RESIZE_BOX_RADIUS * 2) {
        function isInBox(boxX, boxY) {
            return boxX <= x && x <= boxX + radius && boxY <= y && y <= boxY + radius;
        }
        // Left adjust
        if (isInBox(this.bounds.left - radius + 1, yOffset + (this.bounds.top + this.bounds.bottom) / 2 - radius / 2)) return 0;
        // Right adjust
        if (isInBox(this.bounds.right - 1, yOffset + (this.bounds.top + this.bounds.bottom) / 2 - radius / 2)) return 1;
        // Top adjust
        if (isInBox((this.bounds.left + this.bounds.right) / 2 - radius / 2, yOffset + this.bounds.top - radius + 1)) return 2;
        // Bottom adjust
        if (isInBox((this.bounds.left + this.bounds.right) / 2 - radius / 2, yOffset + this.bounds.bottom - 1)) return 3;
        // Try again with the larger radius if we have one
        if (largeRadius && largeRadius > 0) return this.selectedSide(yOffset, x, y, largeRadius, 0);
        // Otherwise we weren't within an adjust box
        return -1;
    }
}
class $a3516c1494a0c6de$export$b18a462967bb13ef {
    constructor(pageIdx, box){
        this.pageIdx = pageIdx;
        this.box = box;
        this.selectedSide = -1;
        this.dragging = false;
        this.selectOrigin = null;
        this.draw = this.draw.bind(this);
        this.mousedown = this.mousedown.bind(this);
        this.mousemove = this.mousemove.bind(this);
        this.mouseup = this.mouseup.bind(this);
    }
    draw(ctx, pages) {
        this.box.draw(ctx, pages[this.pageIdx].top, "#8AC", true, this.selectedSide);
    }
    contains(pages, x, y) {
        return this.box.contains(pages[this.pageIdx].top, x, y) || this.box.selectedSide(pages[this.pageIdx].top, x, y) !== -1;
    }
    isDelete(pages, x, y) {
        return this.box.isDelete(pages[this.pageIdx].top, x, y);
    }
    mousedown(x, y, pages) {
        this.selectedSide = this.box.selectedSide(pages[this.pageIdx].top, x, y);
        this.selectOrigin = {
            x: x,
            y: y
        };
        if (this.selectedSide >= 0) return true;
        this.dragging = this.contains(pages, x, y);
        return this.dragging;
    }
    mousemove(x, y) {
        if (this.dragging) {
            this.box.bounds.left += x - this.selectOrigin.x;
            this.box.bounds.right += x - this.selectOrigin.x;
            this.box.bounds.top += y - this.selectOrigin.y;
            this.box.bounds.bottom += y - this.selectOrigin.y;
        } else switch(this.selectedSide){
            // Left
            case 0:
                this.box.bounds.left += x - this.selectOrigin.x;
                this.box.bounds.left = Math.min(this.box.bounds.left, this.box.bounds.right - 8);
                break;
            // Right
            case 1:
                this.box.bounds.right += x - this.selectOrigin.x;
                this.box.bounds.right = Math.max(this.box.bounds.right, this.box.bounds.left + 8);
                break;
            // Top
            case 2:
                this.box.bounds.top += y - this.selectOrigin.y;
                this.box.bounds.top = Math.min(this.box.bounds.top, this.box.bounds.bottom - 8);
                break;
            // Bottom
            case 3:
                this.box.bounds.bottom += y - this.selectOrigin.y;
                this.box.bounds.bottom = Math.max(this.box.bounds.bottom, this.box.bounds.top + 8);
                break;
            default:
                return;
        }
        if (this.box.bounds.left < 0) this.box.bounds.left = 0;
        if (this.box.bounds.right < 8) this.box.bounds.right = 8;
        this.selectOrigin = {
            x: x,
            y: y
        };
    }
    mouseup(x, y) {
        this.mousemove(x, y);
        this.dragging = false;
        this.selectedSide = -1;
        this.selectOrigin = null;
    }
}



function $d819a9e3ebf7eb88$var$sum(arr) {
    return arr.reduce((a, b)=>a + b, 0);
}
class $d819a9e3ebf7eb88$export$ae272dfa4b541354 {
    constructor(authFetch, canvas){
        this.authFetch = authFetch;
        canvas.width = 0;
        canvas.height = 0;
        this.canvas = canvas;
        this.ctx = canvas.getContext("2d");
        this.width = 0;
        this.height = 0;
        this.pages = [];
        this.selectedBox = null;
        this.draw = this.draw.bind(this);
        this.deselectBox = this.deselectBox.bind(this);
        this.newBox = this.newBox.bind(this);
        this.submit = this.submit.bind(this);
        this.click = this.click.bind(this);
        this.mousedown = this.mousedown.bind(this);
        this.mousemove = this.mousemove.bind(this);
        this.mouseup = this.mouseup.bind(this);
        this.loadDocument = this.loadDocument.bind(this);
        this.showUnredacted = false;
        canvas.addEventListener("click", this.click);
        canvas.addEventListener("mousedown", this.mousedown);
        canvas.addEventListener("mousemove", this.mousemove);
        canvas.addEventListener("mouseup", this.mouseup);
    }
    setVisiblity(show) {
        this.canvas.style.display = show ? "unset" : "none";
    }
    enableUnredacted() {
        this.showUnredacted = true;
        this.canvas.width = this.width * 2;
        this.canvas.style.maxWidth = "2000px";
    }
    disableUnredacted() {
        this.showUnredacted = false;
        this.canvas.width = this.width;
        this.canvas.style.maxWidth = "1000px";
    }
    toggleUnredacted() {
        if (this.showUnredacted) this.disableUnredacted();
        else this.enableUnredacted();
    }
    isShowingUnredacted() {
        return this.showUnredacted;
    }
    draw() {
        if (this.showUnredacted) {
            this.ctx.clearRect(0, 0, this.width * 2, this.height);
            this.ctx.setTransform(1, 0, 0, 1, this.width, 0);
            this.pages.forEach((page)=>page.draw(this.ctx, false));
            this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        } else this.ctx.clearRect(0, 0, this.width, this.height);
        this.pages.forEach((page)=>page.draw(this.ctx));
        if (this.selectedBox) this.selectedBox.draw(this.ctx, this.pages);
    }
    newBox() {
        this.deselectBox();
        const displayedSize = this.ctx.canvas.getBoundingClientRect();
        const scaleY = Number(this.ctx.canvas.height) / displayedSize.height;
        let top = Math.min(this.width / 4, this.height / 3) + scrollY * scaleY;
        const page = this.pages.length - 1;
        const yOffset = this.pages[page].top;
        top -= yOffset;
        this.selectedBox = new (0, $a3516c1494a0c6de$export$b18a462967bb13ef)(page, new (0, $a3516c1494a0c6de$export$e71c4d32a2263218)({
            top: top,
            bottom: top + 20,
            left: this.width / 2 - 25,
            right: this.width / 2 + 25
        }, "black"));
        this.draw();
    }
    deselectBox() {
        if (this.selectedBox) {
            this.pages[this.selectedBox.pageIdx].addBox(this.selectedBox.box);
            this.selectedBox = null;
        }
    }
    async submit() {
        console.log("Submitting!");
        (0, $92acd710bd9304c3$export$b0939f2e76a1d855)();
        this.deselectBox();
        this.draw();
        const boxes = this.pages.map((_)=>[]);
        // Boxes can be dragged between pages, so we can't assume they're on the correct page
        this.pages.flatMap((page)=>page.boxes.map((box)=>[
                    page.top,
                    box
                ])).forEach(([yOffset, box])=>{
            this.pages.map((page, idx)=>[
                    page,
                    idx
                ]).filter(// Take only the page that contains this box
            ([page, idx])=>{
                console.log(idx, page, box.bounds);
                return page.top <= yOffset + box.bounds.top && yOffset + box.bounds.bottom <= page.top + page.height;
            }).forEach(([page, idx])=>{
                boxes[idx].push({
                    Bounds: {
                        left: box.bounds.left / page.scale,
                        right: box.bounds.right / page.scale,
                        top: (page.height - (yOffset + box.bounds.top) + page.top) / page.scale,
                        bottom: (page.height - (yOffset + box.bounds.bottom) + page.top) / page.scale
                    },
                    IsImage: false,
                    HexCode: box.color || "#000000"
                });
            });
        });
        console.log(boxes);
        const resp = await this.authFetch("/submit", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                GroupId: this.groupId,
                DocId: this.docId,
                Boxes: boxes
            })
        });
        if (!resp.ok) {
            alert("An error occured while submitting the document. Please try again. If this persists, please contact support.");
            throw new Error("Submit response not OK");
        }
        (0, $92acd710bd9304c3$export$d841eba85c078f0b)();
        return;
    }
    getEventCoords(ev) {
        const target = ev.target;
        const displayedSize = target.getBoundingClientRect();
        const scaleX = Number(target.width) / displayedSize.width;
        const scaleY = Number(target.height) / displayedSize.height;
        //const xCorrection = this.showUnredacted?this.width:0;
        const xCorrection = 0;
        return {
            x: ev.offsetX * scaleX - xCorrection,
            y: ev.offsetY * scaleY
        };
    }
    mousedown(ev, clicked = false) {
        const { x: x, y: y } = this.getEventCoords(ev);
        if ((!this.selectedBox || !this.selectedBox.mousedown(x, y, this.pages)) && !clicked) {
            this.click(ev, false);
            return this.mousedown(ev, true);
        }
        this.draw();
    }
    mousemove(ev) {
        if (this.selectedBox) {
            const { x: x, y: y } = this.getEventCoords(ev);
            this.selectedBox.mousemove(x, y);
            this.draw();
        }
    }
    mouseup(ev) {
        if (this.selectedBox) {
            const { x: x, y: y } = this.getEventCoords(ev);
            this.selectedBox.mouseup(x, y);
            this.draw();
        }
    }
    click(ev, draw = true) {
        const { x: x, y: y } = this.getEventCoords(ev);
        if (this.selectedBox) {
            if (this.selectedBox.isDelete(this.pages, x, y)) {
                this.selectedBox = null;
                this.draw();
                return;
            }
            if (this.selectedBox.contains(this.pages, x, y)) return;
            this.deselectBox();
        }
        for(let pageIdx = 0; pageIdx < this.pages.length; pageIdx++){
            const box = this.pages[pageIdx].takeBox(x, y);
            if (box) {
                this.selectedBox = new (0, $a3516c1494a0c6de$export$b18a462967bb13ef)(pageIdx, box);
                break;
            }
        }
        if (draw) this.draw();
    }
    async getItem(groupId, docId) {
        // TODO: This only returns the first page of the document.
        // We should obviously allow the user to select a document.
        // Furthermore, we should show the user the document info!!
        console.log("Getting", groupId, docId);
        return this.authFetch("/get-group-highlight-data", {
            method: "POST",
            body: groupId
        }).then((resp)=>{
            if (!resp.ok) throw new Error("non 200 status");
            return resp.json();
        }).then((resp)=>resp.Docs[docId].HighlightDatas);
    }
    async getImage(name) {
        return this.authFetch("/get-img", {
            method: "POST",
            body: name
        }).then((resp)=>{
            if (!resp.ok) throw new Error("non 200 status");
            return resp.blob();
        });
    }
    async loadDocument(groupId, docId) {
        this.selectedBox = null;
        // Get the document info
        const pages = await this.getItem(groupId, docId);
        console.log(groupId);
        console.log(docId);
        console.log(pages);
        const pageInfo = pages.map((page)=>page.Page);
        // Start a request in the background to get all the images
        const imagesPromise = Promise.all(pageInfo.map((page)=>this.getImage(page.ImageBlobName).then(createImageBitmap)));
        // Determine the document dimensions
        const pageWidths = pageInfo.map((page)=>page.Width * page.Scale);
        const pageHeights = pageInfo.map((page)=>page.Height * page.Scale);
        // Generate the pages
        this.pages = (await imagesPromise).map((bitmap, idx)=>{
            const scale = pageInfo[idx].Scale;
            const top = $d819a9e3ebf7eb88$var$sum(pageHeights.slice(0, idx));
            const height = pageHeights[idx];
            function isWithin(box1, box2) {
                return box1.bounds.left >= box2.bounds.left && box1.bounds.right <= box2.bounds.right && box1.bounds.top >= box2.bounds.top && box1.bounds.bottom <= box2.bounds.bottom;
            }
            function calculateOverlapPercentage(box1, box2) {
                const intersectionLeft = Math.max(box1.bounds.left, box2.bounds.left);
                const intersectionRight = Math.min(box1.bounds.right, box2.bounds.right);
                const intersectionTop = Math.max(box1.bounds.top, box2.bounds.top);
                const intersectionBottom = Math.min(box1.bounds.bottom, box2.bounds.bottom);
                const intersectionWidth = intersectionRight - intersectionLeft;
                const intersectionHeight = intersectionBottom - intersectionTop;
                if (intersectionWidth < 0 || intersectionHeight < 0) return 0;
                const intersectionArea = intersectionWidth * intersectionHeight;
                const box1Area = (box1.bounds.right - box1.bounds.left) * (box1.bounds.bottom - box1.bounds.top);
                const overlapPercentage = intersectionArea / box1Area * 100;
                return overlapPercentage;
            }
            function mergeBoxes(box1, box2) {
                const mergedBox = {
                    bounds: {
                        left: Math.min(box1.bounds.left, box2.bounds.left),
                        right: Math.max(box1.bounds.right, box2.bounds.right),
                        top: Math.min(box1.bounds.top, box2.bounds.top),
                        bottom: Math.max(box1.bounds.bottom, box2.bounds.bottom)
                    }
                };
                return mergedBox;
            }
            const boxes = [];
            pages[idx].HighlightBoxes.forEach((box)=>{
                const bounds = box.Bounds;
                bounds.left *= scale;
                bounds.right *= scale;
                bounds.top = height - bounds.top * scale;
                bounds.bottom = height - bounds.bottom * scale;
                let nbox = new (0, $a3516c1494a0c6de$export$e71c4d32a2263218)(bounds, box.HexCode);
                let found = false;
                for(let i = 0; i < boxes.length; i++){
                    if (isWithin(nbox, boxes[i])) {
                        found = true;
                        break;
                    } else if (isWithin(boxes[i], nbox)) {
                        boxes.splice(i, 1);
                        i--;
                    }
                }
                if (!found) {
                    for(let i = 0; i < boxes.length; i++)if (calculateOverlapPercentage(nbox, boxes[i]) > 0) {
                        nbox = new (0, $a3516c1494a0c6de$export$e71c4d32a2263218)(mergeBoxes(boxes[i], nbox).bounds, box.HexCode);
                        break;
                    }
                    boxes.push(nbox);
                }
            });
            for(let i1 = 0; i1 < boxes.length; i1++){
                const nbox = boxes[i1];
                for(let i = 0; i < boxes.length; i++){
                    if (isWithin(nbox, boxes[i])) break;
                    else if (isWithin(boxes[i], nbox)) {
                        boxes.splice(i, 1);
                        i--;
                    }
                }
            }
            return new (0, $60bfd8aa86a84fba$export$6955bcca4cd3539f)(scale, top, height, // Map the boxes from PDF coordinates to pixel coordinates
            boxes, bitmap);
        });
        this.width = Math.max(...pageWidths);
        this.height = $d819a9e3ebf7eb88$var$sum(pageHeights);
        // Add enough padding for a delete button right at the bottom
        this.canvas.height = this.height + 35;
        // This updates the width
        this.disableUnredacted();
        // TODO: draw loading indicator?
        this.groupId = groupId;
        this.docId = docId;
        this.draw();
    }
}


/**
 * Create a HTML element from a component.
 */ function $8a926118a999cd63$var$createComponentElement(component) {
    const textElements = [
        "h1",
        "h2",
        "h3",
        "p",
        "span"
    ];
    for (const textElement of textElements)if (textElement in component) {
        const elem = document.createElement(textElement);
        // @ts-ignore this is fine, typescript thinks I can't index with a string
        elem.append(...$8a926118a999cd63$var$createTextNodes(component[textElement]));
        return elem;
    }
    if ("ul" in component) {
        const ul = document.createElement("ul");
        for (const item of component.ul){
            const li = document.createElement("li");
            if (item.length === 1 && "p" in item[0]) li.append(...$8a926118a999cd63$var$createTextNodes(item[0].p));
            else if (item.length === 1 && "span" in item[0]) li.append(...$8a926118a999cd63$var$createTextNodes(item[0].span));
            else li.append(...item.map($8a926118a999cd63$var$createComponentElement));
            ul.appendChild(li);
        }
        return ul;
    }
    if ("row" in component) {
        const row = document.createElement("div");
        row.classList.add("simple-row");
        row.append(...component.row.map($8a926118a999cd63$var$createComponentElement));
        return row;
    }
    if ("addressRight" in component) {
        const elem = document.createElement("address");
        elem.classList.add("address-right");
        elem.append(...$8a926118a999cd63$var$createTextNodes(component.addressRight));
        return elem;
    }
    if ("table" in component) {
        const table = document.createElement("table");
        for (const row of component.table){
            const rowElem = document.createElement("tr");
            for (const item of row){
                const itemElem = document.createElement("td");
                itemElem.append(...item.map($8a926118a999cd63$var$createComponentElement));
                rowElem.append(itemElem);
            }
            table.append(rowElem);
        }
        return table;
    }
    throw new Error("invalid component: " + JSON.stringify(component));
}
function $8a926118a999cd63$export$d02b61f3cd07d303(doc) {
    const div = document.createElement("div");
    div.classList.add("templated-doc", doc.theme);
    div.append(...doc.components.map($8a926118a999cd63$var$createComponentElement));
    return div;
}
/**
 * Take a string, which must contain the "px" suffix, and remove the suffix before parsing it as a
 * base 10 float.
 */ function $8a926118a999cd63$var$parsePixels(s) {
    if (!s.endsWith("px")) throw new Error("value was not computed in pixels: " + s);
    return parseFloat(s.slice(0, s.length - 2));
}
/**
 * Make the padding of `container` act as page margins.
 *
 * That is, space elements out such that nothing is within the padding of a page break.
 *
 * The page breaks are determined by `pageHeightInches`, which is the intended height of each page,
 * in inches of course!
 */ function $8a926118a999cd63$var$addPageBreaks(pageWidthInches, pageHeightInches, container) {
    // We start by setting the width of the container to the width of the page.
    // If we don't do this, line wraps won't happen in the right place, so all our calculations will
    // be wrong!
    container.style.boxSizing = "border-box";
    container.style.width = `${pageWidthInches}in`;
    // Get the top and bottom margin (actually padding)
    const containerStyle = getComputedStyle(container);
    const paddingTop = $8a926118a999cd63$var$parsePixels(containerStyle.paddingTop);
    const paddingBottom = $8a926118a999cd63$var$parsePixels(containerStyle.paddingBottom);
    // Calculate the height of the page, in pixels.
    // We do this by appending a div with `height` set to the page height, and letting CSS calculate
    // the size in pixels.
    const heightTester = document.createElement("div");
    heightTester.style.height = `${pageHeightInches}in`;
    heightTester.style.display = "none";
    document.body.appendChild(heightTester);
    const pageHeight = $8a926118a999cd63$var$parsePixels(getComputedStyle(heightTester).height);
    document.body.removeChild(heightTester);
    // This tracks which page we're on. We start counting at 1. This makes sense, I promise.
    let page = 1;
    /**
     * Process an element which may need padding adjusting to give a gap over a page break.
     */ function processNode(node) {
        // We only add padding to our basic elements.
        //
        // For any other elements, we process all their children (see the else block).
        //
        // Also, "TR" exists, and is handled slightly differently, see below.
        if ([
            "H1",
            "H2",
            "H3",
            "P",
            "LI",
            "ADDRESS",
            "TR"
        ].includes(node.nodeName) || node.nodeName === "DIV" && node.classList.contains("simple-row")) {
            const elem = node;
            const rect = elem.getBoundingClientRect();
            // We need to check for overflow on every page (since this element could be no lower
            // than the previous element, for example in a table row).
            // We check backwards, since we only need to add padding for the last page it's on.
            for(let checkPage = page; checkPage > 0; checkPage--){
                // If the bottom of the current element falls below where we should cut the page
                // off, we add padding to move it to the top of the next page.
                const pageBottom = pageHeight * checkPage;
                if (rect.bottom > pageBottom - paddingBottom) {
                    // Table rows don't actually need to wrap (since later on we process and
                    // potentially wrap their children).
                    //
                    // But, it's neater if small rows do. We therefore only wrap if the top is close
                    // enough to the bottom of the page.
                    if (elem.nodeName === "TR" && rect.top < pageBottom - paddingBottom * 3) break;
                    // We intend to set the padding top to:
                    // - The gap between but bottom of the page, and the top of the element
                    //   (this moves the element to the top of the next page)
                    // - Plus the paddingTop (to add the top margin)
                    // - Plus the original padding of the element
                    //
                    // To note here: if the element was actually already on the next page, then
                    // `gap` has the side-effect of correcting for this, so we don't break anything!
                    let gap = pageBottom - rect.top;
                    // To avoid editing the padding on everything past the first page, however, we
                    // don't bother if the gap is already large enough! It doesn't break the
                    // appearance without this, but it feels neat to add it.
                    if (gap < -paddingTop) continue;
                    // Something else to think about... When actually printing, the padding isn't
                    // from the last element, but instead from the top of the page. So, in this
                    // case, the gap should max out at 0.
                    //
                    // We can't apply this now, however. If we did, our calculations wouldn't work
                    // because, on the page we're working with, the padding is still from the
                    // previous element.
                    //
                    // This function does this for us!
                    $8a926118a999cd63$var$applyExtraPaddingTop(elem, gap + paddingTop, Math.min(gap, 0) + paddingTop);
                    // Remove the top margin, this this has been "merged into the page margin"
                    elem.style.marginTop = "0px";
                    // We're nearly there.
                    //
                    // Yes, I've been doing this for more than 24 hours now.
                    //
                    // Thanks to the print logic above, we might no longer have enough padding and
                    // margin to force a page break naturally. So we need to force it.
                    elem.style.pageBreakBefore = "always";
                    // If we've processed an element that's been moved to a new page, we're now on
                    // the next page, so increment the page counter!
                    if (checkPage === page) page++;
                    break;
                }
            }
            // Finally, content within table rows should also wrap itself.
            if (elem.nodeName === "TR") [
                ...node.children
            ].forEach(processNode);
        } else [
            ...node.children
        ].forEach(processNode);
    }
    [
        ...container.children
    ].forEach(processNode);
    // Afterwards, to ensure the div background covers the entirety of the last page, set the
    // height to the exact height of the correct number of pages.
    container.style.height = `${page * pageHeightInches}in`;
}
/**
 * Add extra padding to the top of an element.
 *
 * `extraPaddingTop` is applied when not printing, `extraPaddingTopPrint` is applied when printing.
 *
 * This is achieved by setting the `--print-padding-top` CSS variable, which some handy css in
 * prelude.css applies for us (instead of the normal padding) only when printing!
 */ function $8a926118a999cd63$var$applyExtraPaddingTop(elem, extraPaddingTop, extraPaddingTopPrint) {
    if (elem.nodeName !== "TR") {
        // Most elements are fairly simple:
        //
        // We get the current padding
        const paddingTop = $8a926118a999cd63$var$parsePixels(getComputedStyle(elem).paddingTop);
        // And the current print padding (which is either the normal padding, or the CSS variable if
        // it's set)
        const printPaddingStr = elem.style.getPropertyValue("--print-padding-top");
        const printPaddingTop = printPaddingStr ? $8a926118a999cd63$var$parsePixels(printPaddingStr) : paddingTop;
        // Then we apply the new values!
        elem.style.paddingTop = `${paddingTop + extraPaddingTop}px`;
        elem.style.setProperty("--print-padding-top", `${printPaddingTop + extraPaddingTopPrint}px`);
        elem.classList.add("apply-print-padding-top");
    } else // Table rows, however, can't have padding, so we have to instead apply it to the children.
    for (const td of elem.children)$8a926118a999cd63$var$applyExtraPaddingTop(td, extraPaddingTop, extraPaddingTopPrint);
}
/**
 * Clear the body, and insert only the rendered document.
 *
 * This ignores the document size and margin, the printer should handle these properties.
 */ function $8a926118a999cd63$var$replaceBodyWithDoc(doc) {
    document.body.innerHTML = "";
    const div = $8a926118a999cd63$export$d02b61f3cd07d303(doc);
    document.body.appendChild(div);
    if (doc.i_am_sorry) {
        div.classList.add("with-pages");
        $8a926118a999cd63$var$addPageBreaks(doc.page_width, doc.page_height, div);
    }
}
// @ts-ignore
window.replaceBodyWithDoc = $8a926118a999cd63$var$replaceBodyWithDoc;
const $8a926118a999cd63$export$e289450312262e99 = [
    "fontWeight",
    "textDecoration",
    "fontStyle",
    "fontVariantPosition",
    "fontVariant",
    "verticalAlign"
];
function $8a926118a999cd63$export$d1f54684dbcceaa6(propertyName) {
    return propertyName.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function $8a926118a999cd63$var$createTextNodes(text) {
    if (typeof text === "string") {
        const node = document.createTextNode(text);
        return [
            node
        ];
    }
    if (Array.isArray(text)) return text.map($8a926118a999cd63$var$createTextNodes).flat();
    const result = document.createElement("span");
    result.append(...$8a926118a999cd63$var$createTextNodes(text.content));
    for (const elem of $8a926118a999cd63$export$e289450312262e99)if (elem in text.style) result.style.setProperty($8a926118a999cd63$export$d1f54684dbcceaa6(elem), text.style[elem]);
    return [
        result
    ];
}



class $e171fde8ab20f96f$export$be11ee6d0af51935 {
    constructor(authFetch, embedPdf, templateDiv){
        this.nextTableID = 1;
        this.currentTableID = 0;
        this.authFetch = authFetch;
        this.embedPdf = embedPdf;
        this.templateDiv = templateDiv;
        this.showToolbar = this.showToolbar.bind(this);
        this.removeToolbar = this.removeToolbar.bind(this);
        this.changeElement = this.changeElement.bind(this);
        this.hoverButtons = this.hoverButtons.bind(this);
        this.removeHoverButtons = this.removeHoverButtons.bind(this);
        this.tableButtons = this.tableButtons.bind(this);
        this.removeTableButtons = this.removeTableButtons.bind(this);
        this.keyHandler = this.keyHandler.bind(this);
        this.bar = false;
        this.templateDiv.addEventListener("mouseleave", ()=>{
            this.removeHoverButtons();
            this.removeTableButtons();
        });
        this.contextMenu = this.contextMenu.bind(this);
        this.addListeners = this.addListeners.bind(this);
        this.HTMLtoComponent = this.HTMLtoComponent.bind(this);
        this.parseComponent = this.parseComponent.bind(this);
        this.parse = this.parse.bind(this);
        document.addEventListener("click", ()=>{
            templateDiv.querySelectorAll("menu").forEach((menu)=>menu.remove());
        });
    }
    fetchAndEdit(groupId, docId) {
        this.groupId = groupId;
        this.docId = docId;
        // TODO we should show the user the document info in some way
        console.log("Getting templated", groupId, docId);
        return Promise.all([
            this.authFetch("/get-pdf", {
                method: "POST",
                body: JSON.stringify({
                    GroupId: groupId,
                    DocId: docId
                })
            }).then((resp)=>{
                if (!resp.ok) throw new Error("non 200 status");
                return resp.blob();
            }).then((blob)=>{
                this.embedPdf.src = URL.createObjectURL(blob) + "#navpanes=0";
            }),
            this.authFetch("/get-templated-doc", {
                method: "POST",
                body: groupId + "/" + docId
            }).then((resp)=>{
                if (!resp.ok) throw new Error("non 200 status");
                return resp.json();
            }).then(({ doc: doc })=>this.edit(doc))
        ]);
    }
    edit(doc) {
        this.doc = doc;
        this.renderedDiv = (0, $8a926118a999cd63$export$d02b61f3cd07d303)(doc);
        this.renderedDiv.querySelectorAll("h1, h2, h3, ul, p, address, table").forEach((node)=>{
            this.addListeners(node);
        });
        this.templateDiv.style.paddingTop = `${doc.page_margin_top}in`;
        this.templateDiv.style.paddingBottom = `${doc.page_margin_bottom}in`;
        this.templateDiv.style.paddingLeft = `${doc.page_margin_left}in`;
        this.templateDiv.style.paddingRight = `${doc.page_margin_right}in`;
        this.templateDiv.style.width = `${doc.page_width}in`;
        this.templateDiv.innerHTML = "";
        this.templateDiv.appendChild(this.renderedDiv);
    }
    addListeners(elem) {
        if (elem.nodeName === "TABLE") {
            elem.addEventListener("contextmenu", this.contextMenu);
            elem.addEventListener("mouseover", ()=>this.tableButtons(elem));
        } else {
            $e171fde8ab20f96f$var$plaintext(elem);
            elem.addEventListener("focus", this.showToolbar);
            elem.addEventListener("focusout", this.removeToolbar);
            elem.addEventListener("keydown", this.keyHandler);
            elem.addEventListener("mouseover", ()=>this.hoverButtons(elem));
        }
    }
    HTMLtoComponent(parent) {
        const children = [
            ...parent.childNodes
        ];
        // If every child is a span or text node, we can just use parseComponent.
        if (children.every((child)=>child.nodeType === Node.TEXT_NODE || child.nodeName === "SPAN")) return [
            {
                span: this.parseComponent(parent)
            }
        ];
        const components = [];
        children.forEach((node)=>{
            if (node.nodeType === Node.TEXT_NODE) {
                components.push({
                    span: node.textContent || ""
                });
                return;
            }
            const elem = node;
            switch(elem.nodeName){
                case "H1":
                    components.push({
                        h1: this.parseComponent(elem)
                    });
                    break;
                case "H2":
                    components.push({
                        h2: this.parseComponent(elem)
                    });
                    break;
                case "H3":
                    components.push({
                        h3: this.parseComponent(elem)
                    });
                    break;
                case "P":
                    components.push({
                        p: this.parseComponent(elem)
                    });
                    break;
                case "ADDRESS":
                    if (elem.classList.contains("address-right")) components.push({
                        addressRight: this.parseComponent(elem)
                    });
                    break;
                case "UL":
                    components.push({
                        ul: [
                            ...elem.children
                        ].filter((child)=>child.nodeName === "LI").map(this.HTMLtoComponent)
                    });
                    break;
                case "TABLE":
                    components.push({
                        table: [
                            ...elem.children
                        ].filter((firstChild)=>firstChild.nodeName === "TR").map((row)=>[
                                ...row.children
                            ].filter((item)=>item.nodeName === "TD").map(this.HTMLtoComponent))
                    });
                    break;
                case "DIV":
                    if (elem.classList.contains("simple-row")) {
                        components.push({
                            row: this.HTMLtoComponent(elem)
                        });
                        break;
                    }
                // fallthrough here, since we don't know what this div is
                default:
                    console.error("unknown node name: " + elem.nodeName);
                    break;
            }
        });
        return components;
    }
    parseComponent(component) {
        const result = [];
        component.childNodes.forEach((node)=>{
            if (node.nodeType === Node.TEXT_NODE) result.push(node.textContent || "");
            else {
                const elem = node;
                let style = {};
                const type = elem.nodeName;
                switch(type){
                    case "B":
                        style.fontWeight = "bold";
                        break;
                    case "I":
                        style.fontStyle = "italic";
                        break;
                    case "U":
                        style.textDecoration = "underline";
                        break;
                    case "S":
                        style.textDecoration = "line-through";
                        break;
                    case "SUP":
                        style.verticalAlign = "super";
                        break;
                    case "SUB":
                        style.verticalAlign = "sub";
                        break;
                    case "SPAN":
                        for (const prop of (0, $8a926118a999cd63$export$e289450312262e99)){
                            const value = elem.style.getPropertyValue((0, $8a926118a999cd63$export$d1f54684dbcceaa6)(prop));
                            if (value) style[prop] = value;
                        }
                        break;
                    default:
                        const computed = getComputedStyle(elem);
                        for (const prop of (0, $8a926118a999cd63$export$e289450312262e99)){
                            const value = computed.getPropertyValue((0, $8a926118a999cd63$export$d1f54684dbcceaa6)(prop));
                            if (value) style[prop] = value;
                        }
                }
                result.push({
                    content: this.parseComponent(elem) || "",
                    style: style
                });
            }
        });
        return result.length === 1 ? result[0] : result;
    }
    parse() {
        if (!this.doc || !this.renderedDiv) throw new Error("You cannot save a doc if you haven't opened one.");
        return {
            ...this.doc,
            components: this.HTMLtoComponent(this.renderedDiv)
        };
    }
    save() {
        (0, $92acd710bd9304c3$export$b0939f2e76a1d855)();
        return this.authFetch("/submit-templated-doc", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                GroupId: this.groupId,
                DocId: this.docId,
                Doc: this.parse()
            })
        }).then((resp)=>{
            if (!resp.ok) throw new Error("non 200 status");
            (0, $92acd710bd9304c3$export$d841eba85c078f0b)();
        });
    }
    setVisibility(show) {
        this.templateDiv.style.display = show ? "unset" : "none";
    }
    showToolbar(ev) {
        const target = ev.target;
        const bar = document.createElement("div");
        bar.className = "toolbar";
        const rect = target.getBoundingClientRect();
        const outerRect = this.templateDiv.getBoundingClientRect();
        this.removeToolbar();
        bar.style.left = `${15 + outerRect.left}px`;
        bar.style.top = "15px";
        const boldLabel = document.createElement("b");
        boldLabel.innerText = "B";
        bar.appendChild(this.toolbarButton(()=>{
            target.contentEditable = "true";
            document.execCommand("bold");
            $e171fde8ab20f96f$var$plaintext(target);
        }, boldLabel));
        const underlineLabel = document.createElement("u");
        underlineLabel.innerText = "U";
        bar.appendChild(this.toolbarButton(()=>{
            target.contentEditable = "true";
            document.execCommand("underline");
            $e171fde8ab20f96f$var$plaintext(target);
        }, underlineLabel));
        const italicLabel = document.createElement("i");
        italicLabel.innerText = "I";
        bar.appendChild(this.toolbarButton(()=>{
            target.contentEditable = "true";
            document.execCommand("italic");
            $e171fde8ab20f96f$var$plaintext(target);
        }, italicLabel));
        //const strikeLabel = document.createElement("s");
        //strikeLabel.innerText = "S";
        //bar.appendChild(this.toolbarButton(() => {
        //    target.contentEditable = "true";
        //    document.execCommand("strikethrough");
        //    target.contentEditable = "plaintext-only";
        //},
        //    strikeLabel))
        const superLabel = document.createElement("span");
        superLabel.innerText = "x\xb2";
        bar.appendChild(this.toolbarButton(()=>{
            target.contentEditable = "true";
            document.execCommand("superscript");
            $e171fde8ab20f96f$var$plaintext(target);
        }, superLabel));
        //const subLabel = document.createElement("sub");
        //subLabel.innerText = "x";
        //bar.appendChild(this.toolbarButton(() => {
        //    target.contentEditable = "true";
        //    document.execCommand("subscript");
        //    target.contentEditable = "plaintext-only";
        //},
        //    subLabel))
        const tableSize = document.createElement("table");
        tableSize.classList.add("new-table");
        for(let row = 1; row < 6; row++){
            const newRow = document.createElement("tr");
            tableSize.append(newRow);
            for(let col = 1; col < 6; col++){
                const button = document.createElement("td");
                button.onclick = ()=>buildTable(row, col);
                newRow.append(button);
            }
        }
        const buildTable = (rows, cols)=>{
            const table = document.createElement("table");
            this.addListeners(table);
            for(let rowCount = 0; rowCount < rows; rowCount++){
                const row = document.createElement("tr");
                table.appendChild(row);
                for(let colCount = 0; colCount < cols; colCount++){
                    const cell = document.createElement("td");
                    const para = document.createElement("p");
                    this.addListeners(para);
                    cell.appendChild(para);
                    row.appendChild(cell);
                }
            }
            let node = document.getSelection()?.anchorNode;
            while(![
                "H1",
                "H2",
                "H3",
                "UL",
                "P",
                "ADDRESS"
            ].includes(node?.nodeName)){
                node = node?.parentElement;
                if (!node) throw new Error("Failed to find a suitable node.");
            }
            node.after(table);
        };
        // CSS does some magic here to make the table popup appear on hover
        bar.appendChild(this.toolbarButton(()=>{}, "table", undefined, tableSize));
        if (target.nodeName === "UL") ;
        else {
            bar.appendChild(this.toolbarButton(()=>this.changeElement("h1"), "h1"));
            bar.appendChild(this.toolbarButton(()=>this.changeElement("h2"), "h2"));
            bar.appendChild(this.toolbarButton(()=>this.changeElement("h3"), "h3"));
            bar.appendChild(this.toolbarButton(()=>this.changeElement("p"), "p"));
        }
        bar.appendChild(this.toolbarButton(()=>{
            const node = target;
            if (node.nodeName !== "UL") {
                node.contentEditable = "false";
                const parent = node.parentElement;
                const after = node?.nextSibling;
                const list = document.createElement("ul");
                this.addListeners(list);
                const item = document.createElement("li");
                list.appendChild(item);
                item.appendChild(this.changeElement("P"));
                parent.insertBefore(list, after);
                list.focus();
            } else {
                [
                    ...node.children
                ]// Consider the children of each list item.
                .flatMap((li)=>[
                        ...li.childNodes
                    ])// :D
                .reverse().forEach((child)=>{
                    if (child.nodeType === Node.TEXT_NODE) {
                        const para = document.createElement("p");
                        this.addListeners(para);
                        para.innerHTML = child.textContent;
                        node.after(para);
                        para.focus();
                    } else if (child.nodeType === Node.ELEMENT_NODE) {
                        this.addListeners(child);
                        node.after(child);
                        child.focus();
                    }
                });
                node.remove();
            }
        }, "\u22EE\u2630"));
        bar.appendChild(this.toolbarButton(()=>{
            target.remove();
            this.removeHoverButtons();
            this.removeToolbar();
        }, "\uD83D\uDDD1\uFE0F"));
        bar.addEventListener("mousedown", (ev)=>ev.preventDefault());
        bar.addEventListener("mouseup", (ev)=>ev.preventDefault());
        bar.addEventListener("click", (ev)=>ev.preventDefault());
        this.templateDiv.appendChild(bar);
        this.bar = true;
    }
    hoverButtons(target) {
        this.removeHoverButtons();
        let inTable = false;
        {
            let parent = target.parentElement;
            while(parent && parent.nodeName !== "TABLE")parent = parent.parentElement;
            if (parent) inTable = true;
        }
        const padding = 8;
        const rect = target.getBoundingClientRect();
        const outerRect = this.templateDiv.getBoundingClientRect();
        //directional buttons
        const downOuter = document.createElement("div");
        const down = this.toolbarButton(()=>{
            let node = target;
            while(node.parentElement && !node.parentElement.classList.contains("templated-doc") && !(node.parentElement.nodeName !== "TABLE"))node = node.parentElement;
            if (!node.parentElement) throw new Error("Failed to find parent.");
            const para = document.createElement("P");
            this.addListeners(para);
            node.after(para);
            para.focus();
        }, "+");
        down.classList.add("hover-button");
        if (inTable) down.classList.add("small");
        downOuter.style.position = "absolute";
        downOuter.style.transform = "translateX(-50%)";
        downOuter.style.top = `${rect.bottom - outerRect.top}px`;
        downOuter.style.left = `${rect.left - outerRect.left + rect.width / 2}px`;
        down.style.position = "relative";
        down.style.top = `${padding}px`;
        downOuter.appendChild(down);
        this.templateDiv.appendChild(downOuter);
        const upOuter = document.createElement("div");
        const up = this.toolbarButton(()=>{
            let node = target;
            while(node.parentElement && !node.parentElement?.classList.contains("templated-doc") && !(node.parentElement.nodeName !== "TABLE"))node = node.parentElement;
            if (!node.parentElement) throw new Error("Failed to find parent.");
            const para = document.createElement("P");
            this.addListeners(para);
            node.before(para);
            para.focus();
        }, "+");
        up.classList.add("hover-button");
        if (inTable) up.classList.add("small");
        upOuter.style.position = "absolute";
        upOuter.style.transform = "translateX(-50%)";
        upOuter.style.top = `${rect.top - outerRect.top - padding}px`;
        upOuter.style.left = `${rect.left - outerRect.left + rect.width / 2}px`;
        up.style.position = "relative";
        upOuter.style.height = `${padding}px`;
        up.style.transform = "translateY(-100%)";
        upOuter.appendChild(up);
        this.templateDiv.appendChild(upOuter);
        let cell = target;
        while(cell && cell.nodeName !== "TD")cell = cell?.parentElement;
        let row = cell?.parentElement;
        while(row && row.nodeName !== "TR")row = row?.parentElement;
        let table = row?.parentElement;
        while(table && table.nodeName !== "TABLE")table = table?.parentElement;
        const rightOuter = document.createElement("div");
        const right = this.toolbarButton(inTable ? ()=>this.addColumn(target, "after") : ()=>{
            const node = target;
            let parent = node;
            while(parent && !parent.classList.contains("simple-row"))parent = parent.parentElement;
            const para = document.createElement("P");
            this.addListeners(para);
            if (parent) {
                node.after(para);
                para.focus();
            } else {
                parent = node.parentElement;
                const row = document.createElement("div");
                row.className = "simple-row";
                const after = node?.nextSibling;
                node?.remove();
                row.appendChild(node);
                row.appendChild(para);
                parent.appendChild(row);
                parent.insertBefore(row, after || null);
                para.focus();
            }
        }, "+");
        right.classList.add("hover-button");
        if (inTable) right.classList.add("small");
        rightOuter.style.position = "absolute";
        rightOuter.style.transform = "translateY(-50%)";
        rightOuter.style.top = `${rect.top - outerRect.top + rect.height / 2}px`;
        rightOuter.style.left = `${rect.right - outerRect.left}px`;
        right.style.position = "relative";
        right.style.left = `${padding}px`;
        rightOuter.appendChild(right);
        this.templateDiv.appendChild(rightOuter);
        const leftOuter = document.createElement("div");
        const left = this.toolbarButton(inTable ? ()=>this.addColumn(target, "before") : ()=>{
            const node = target;
            let parent = node;
            while(parent && !parent.classList.contains("simple-row"))parent = parent.parentElement;
            const para = document.createElement("P");
            this.addListeners(para);
            if (parent) {
                node.before(para);
                para.focus();
            } else {
                parent = node.parentElement;
                const row = document.createElement("div");
                row.className = "simple-row";
                const after = node?.nextSibling;
                node?.remove();
                row.appendChild(para);
                row.appendChild(node);
                parent.appendChild(row);
                parent.insertBefore(row, after || null);
                para.focus();
            }
        }, "+");
        left.classList.add("hover-button");
        if (inTable) left.classList.add("small");
        leftOuter.style.position = "absolute";
        leftOuter.style.transform = "translateY(-50%)";
        leftOuter.style.top = `${rect.top - outerRect.top + rect.height / 2}px`;
        leftOuter.style.right = `${outerRect.right - rect.left}px`;
        leftOuter.style.width = `${padding}px`;
        left.style.position = "relative";
        left.style.transform = "translateX(-100%)";
        leftOuter.appendChild(left);
        this.templateDiv.appendChild(leftOuter);
        if (inTable) this.checkIntersects();
        else this.removeTableButtons();
    }
    removeHoverButtons() {
        this.templateDiv.querySelectorAll(".hover-button").forEach((button)=>button.remove());
    }
    checkIntersects() {
        const hoverButtons = document.querySelectorAll(".hover-button");
        document.querySelectorAll(".table-button").forEach((table)=>{
            table.classList.remove("slide");
            hoverButtons.forEach((hover)=>{
                if ($e171fde8ab20f96f$var$intersect(table.getBoundingClientRect(), hover.getBoundingClientRect())) table.classList.add("slide");
            });
        });
    }
    tableButtons(target) {
        /** Helper function to set css variables so I can make the buttons move */ function setVar(variable, val) {
            const root = document.querySelector(":root");
            root.style.setProperty(variable, val);
        }
        let id = target.getAttribute("data-table-id");
        if (id && id === this.currentTableID.toString()) return;
        if (!id) {
            target.setAttribute("data-table-id", this.nextTableID.toString());
            id = this.nextTableID.toString();
            this.nextTableID++;
        }
        this.currentTableID = Number.parseInt(id);
        this.removeTableButtons();
        const padding = 8;
        const rect = target.getBoundingClientRect();
        const outerRect = this.templateDiv.getBoundingClientRect();
        setVar("--upTop", `${rect.top - outerRect.top}px`);
        setVar("--downTop", `${rect.bottom - outerRect.top + padding}px`);
        setVar("--left", `${rect.left - outerRect.left + rect.width / 2}px`);
        const down = this.toolbarButton(()=>{
            let node = target;
            while(node.parentElement && !node.parentElement.classList.contains("templated-doc") && !(node.parentElement.nodeName !== "TABLE"))node = node.parentElement;
            if (!node.parentElement) throw new Error("Failed to find parent.");
            const para = document.createElement("P");
            this.addListeners(para);
            node.after(para);
            para.focus();
        }, "+");
        down.classList.add("table-button");
        down.id = "table-down";
        this.templateDiv.appendChild(down);
        const up = this.toolbarButton(()=>{
            let node = target;
            while(node.parentElement && !node.parentElement?.classList.contains("templated-doc") && !(node.parentElement.nodeName !== "TABLE"))node = node.parentElement;
            if (!node.parentElement) throw new Error("Failed to find parent.");
            const para = document.createElement("P");
            this.addListeners(para);
            node.before(para);
            para.focus();
        }, "+");
        up.classList.add("table-button");
        up.id = "table-up";
        this.templateDiv.appendChild(up);
        this.checkIntersects();
    }
    removeTableButtons() {
        this.currentTableID = 0;
        this.templateDiv.querySelectorAll(".table-button").forEach((button)=>button.remove());
    }
    toolbarButton(onClick, label, img, hoverDiv) {
        const button = document.createElement("button");
        button.className = "toolbar-button";
        button.type = "button";
        button.onclick = (ev)=>{
            ev.preventDefault();
            onClick();
        };
        if (typeof label === "string") button.innerText = label;
        else if (label) button.appendChild(label);
        if (img) {
            const image = document.createElement("img");
            image.src = img;
            button.appendChild(image);
        }
        if (hoverDiv) {
            hoverDiv.classList.add("hover-div");
            button.append(hoverDiv);
        }
        button.addEventListener("mousedown", (ev)=>ev.preventDefault());
        button.addEventListener("mouseup", (ev)=>ev.preventDefault());
        return button;
    }
    removeToolbar() {
        if (this.bar) this.templateDiv.querySelector(".toolbar")?.remove();
    }
    keyHandler(ev) {
        const elem = ev.target;
        let component = elem;
        while(![
            "H1",
            "H2",
            "H3",
            "UL",
            "P",
            "ADDRESS",
            "TABLE"
        ].includes(elem?.nodeName)){
            component = elem?.parentElement;
            if (!component) throw new Error("Failed to find a suitable node.");
        }
        requestAnimationFrame(()=>component && this.hoverButtons(component));
        if (ev.key === "Enter" && elem.nodeName === "UL") {
            ev.preventDefault();
            const selection = document.getSelection();
            const caretPosition = selection?.anchorOffset;
            let anchorNode = selection.anchorNode;
            while(anchorNode.nodeName !== "LI")anchorNode = anchorNode.parentElement;
            const content = [
                anchorNode.textContent?.substring(0, caretPosition),
                anchorNode.textContent?.substring(caretPosition)
            ];
            anchorNode.textContent = content[0];
            const newItem = document.createElement("li");
            anchorNode.after(newItem);
            newItem.innerText = content[1];
            document.getSelection()?.modify("move", "forward", "paragraph");
        }
        if (ev.key === "Backspace" && elem.nodeName === "UL" && document.getSelection()?.anchorOffset === 0) {
            ev.preventDefault();
            const elem = document.getSelection()?.anchorNode;
            document.getSelection()?.modify("move", "backward", "character");
            elem.remove();
        }
    }
    changeElement(newType) {
        const selection = document.getSelection();
        let node = selection?.anchorNode;
        while(![
            "H1",
            "H2",
            "H3",
            "UL",
            "P",
            "ADDRESS"
        ].includes(node?.nodeName)){
            node = node?.parentElement;
            if (!node) throw new Error("Failed to find a suitable node.");
        }
        const replacement = document.createElement(newType);
        replacement.innerHTML = node.innerHTML;
        this.addListeners(replacement);
        node.replaceWith(replacement);
        replacement.focus();
        return replacement;
    }
    contextMenu(ev) {
        this.templateDiv.querySelectorAll("menu").forEach((menu)=>menu.remove());
        if (ev.button !== 2) return;
        ev.preventDefault();
        let cell = ev.target;
        while(cell && cell.nodeName !== "TD")cell = cell?.parentElement;
        let row = cell?.parentElement;
        while(row && row.nodeName !== "TR")row = row?.parentElement;
        let table = row?.parentElement;
        while(table && table.nodeName !== "TABLE")table = table?.parentElement;
        if (!(cell && row && table)) return;
        const colCount = [
            ...row.children
        ].filter((item)=>item.nodeName === "TD").length;
        const menu = document.createElement("menu");
        menu.style.top = `${ev.clientY}px`;
        menu.style.left = `${ev.clientX}px`;
        this.templateDiv.append(menu);
        const above = document.createElement("button");
        above.setAttribute("type", "button");
        above.innerText = "Insert row above";
        above.onclick = ()=>{
            const newRow = document.createElement("tr");
            for(let i = 0; i < colCount; i++){
                const newCell = document.createElement("td");
                const newPara = document.createElement("p");
                this.addListeners(newPara);
                newCell.append(newPara);
                newRow.append(newCell);
            }
            row.before(newRow);
            menu.remove();
        };
        menu.append(above);
        const below = document.createElement("button");
        below.setAttribute("type", "button");
        below.innerText = "Insert row below";
        below.onclick = ()=>{
            const newRow = document.createElement("tr");
            for(let i = 0; i < colCount; i++){
                const newCell = document.createElement("td");
                const newPara = document.createElement("p");
                this.addListeners(newPara);
                newCell.append(newPara);
                newRow.append(newCell);
            }
            row.after(newRow);
            menu.remove();
        };
        menu.append(below);
        const left = document.createElement("button");
        left.setAttribute("type", "button");
        left.innerText = "Insert column left";
        left.onclick = ()=>{
            this.addColumn(cell, "before");
            menu.remove();
        };
        menu.append(left);
        const right = document.createElement("button");
        right.setAttribute("type", "button");
        right.innerText = "Insert column right";
        right.onclick = ()=>{
            this.addColumn(cell, "after");
            menu.remove();
        };
        menu.append(right);
        const deleteRow = document.createElement("button");
        deleteRow.setAttribute("type", "button");
        deleteRow.innerText = "Delete row";
        deleteRow.onclick = ()=>{
            row.remove();
            menu.remove();
        };
        menu.append(deleteRow);
        const deleteCol = document.createElement("button");
        deleteCol.setAttribute("type", "button");
        deleteCol.innerText = "Delete column";
        deleteCol.onclick = ()=>{
            const cells = [
                ...row.children
            ];
            let col = 0;
            while(cells[col] !== cell)col++;
            const rows = [
                ...table.children
            ].filter((row)=>row.nodeName === "TR");
            if ([
                ...rows[0].children
            ].length === 1) return;
            rows.forEach((row)=>[
                    ...row.children
                ][col].remove());
            menu.remove();
        };
        menu.append(deleteCol);
    }
    /**
     * adds a column to a table based on a passed cell
     * @param cell either the cell itself, or any node within that cell
     * @param position must be "before" or "after" to choose new column position
     */ addColumn(cell, position) {
        let start = cell;
        while(start && start.nodeName !== "TD")start = start?.parentElement;
        let row = start?.parentElement;
        while(row && row.nodeName !== "TR")row = row?.parentElement;
        let table = row?.parentElement;
        while(table && table.nodeName !== "TABLE")table = table?.parentElement;
        if (!(start && row && table)) throw new Error("Invalid node passed.");
        const cells = [
            ...row.children
        ];
        let col = 0;
        while(cells[col] !== start)col++;
        const rows = [
            ...table.children
        ].filter((row)=>row.nodeName === "TR");
        if (position.toLowerCase() === "before") rows.forEach((row)=>{
            let newCell = document.createElement("td");
            let newPara = document.createElement("p");
            this.addListeners(newPara);
            newCell.append(newPara);
            [
                ...row.children
            ][col].before(newCell);
        });
        else if (position.toLowerCase() === "after") rows.forEach((row)=>{
            let newCell = document.createElement("td");
            let newPara = document.createElement("p");
            this.addListeners(newPara);
            newCell.append(newPara);
            [
                ...row.children
            ][col].after(newCell);
        });
        else throw new Error("Not a valid position, must be 'before' or 'after'.");
    }
}
function $e171fde8ab20f96f$var$intersect(first, second) {
    let horizontal = false;
    horizontal ||= first.left <= second.left && second.left <= first.right;
    horizontal ||= second.left <= first.left && first.left <= second.right;
    horizontal ||= first.left <= second.right && second.right <= first.right;
    horizontal ||= second.left <= first.right && first.right <= second.right;
    let vertical = false;
    vertical ||= first.top <= second.top && second.top <= first.bottom;
    vertical ||= second.top <= first.top && first.top <= second.bottom;
    vertical ||= first.top <= second.bottom && second.bottom <= first.bottom;
    vertical ||= second.top <= first.bottom && first.bottom <= second.bottom;
    return horizontal && vertical;
}
function $e171fde8ab20f96f$var$plaintext(elem) {
    try {
        elem.contentEditable = "plaintext-only";
    } catch (error) {
        elem.contentEditable = "true";
    }
}


/**
 * Return a promise that resolves after `duration` milliseconds.
 */ function $28f61b992d9efbdc$var$sleep(duration) {
    return new Promise((resolve)=>setTimeout(()=>resolve(), duration));
}
/**
 * Returns true iff `xs` and `ys` have the same elements (in any order).
 */ function $28f61b992d9efbdc$var$setsEqual(xs, ys) {
    for (const x of xs)if (!ys.includes(x)) return false;
    for (const y of ys)if (!xs.includes(y)) return false;
    return true;
}
/**
 * Returns true iff `a` and `b` have the same keys, with the same values.
 */ function $28f61b992d9efbdc$var$recordsEqual(a, b) {
    const aKeys = Object.keys(a);
    // The objects must have the same keys
    if (!$28f61b992d9efbdc$var$setsEqual(aKeys, Object.keys(b))) return false;
    // And, if they do have the same keys, each value must be equal.
    for (const key of aKeys)if (a[key] !== b[key]) return false;
    return true;
}
function $28f61b992d9efbdc$var$testRecordsEqual() {
    const a = {
        a: 1
    };
    const b = {
        b: 2
    };
    const b3 = {
        b: 3
    };
    const ab3 = {
        a: 1,
        b: 3
    };
    const ab32 = {
        a: 1,
        b: 3
    };
    const ab5 = {
        a: 1,
        b: 5
    };
    const ab2 = {
        a: 2,
        b: 3
    };
    const anotherA = {
        a: 1
    };
    const anotherB3 = {
        b: 3
    };
    console.assert($28f61b992d9efbdc$var$recordsEqual(a, anotherA));
    console.assert(!$28f61b992d9efbdc$var$recordsEqual(a, b));
    console.assert(!$28f61b992d9efbdc$var$recordsEqual(a, b3));
    console.assert($28f61b992d9efbdc$var$recordsEqual(anotherB3, b3));
    console.assert(!$28f61b992d9efbdc$var$recordsEqual(b, b3));
    console.assert($28f61b992d9efbdc$var$recordsEqual(ab3, ab32));
    console.assert(!$28f61b992d9efbdc$var$recordsEqual(ab3, a));
    console.assert(!$28f61b992d9efbdc$var$recordsEqual(ab3, b3));
    console.assert(!$28f61b992d9efbdc$var$recordsEqual(ab3, b));
    console.assert(!$28f61b992d9efbdc$var$recordsEqual(ab3, ab2));
    console.assert(!$28f61b992d9efbdc$var$recordsEqual(ab3, ab5));
}
class $28f61b992d9efbdc$export$7cda8d932e2f33c0 {
    /**
     * @param authFetch - The function to use to make authenticated API calls
     * @param doList - If false, the document list is not loaded. This should be used if you intend to
     * call `singleAccess`, and not display the document list.
     */ constructor(authFetch, ui, doList){
        this.DocumentType = {
            "0": "None",
            "1": "CV",
            "2": "Application Form",
            "3": "Cover Letter",
            "4": "Statement Of Work",
            "10": "Other"
        };
        this.authFetch = authFetch;
        this.ui = ui;
        this.redactionBoxEditor = new (0, $d819a9e3ebf7eb88$export$ae272dfa4b541354)(authFetch, ui.display);
        this.templatedDocEditor = new (0, $e171fde8ab20f96f$export$be11ee6d0af51935)(authFetch, ui.pdfDisplay, ui.templatingDisplay);
        //this.webSocket = new WebSocket(`ws://${location.host}/todo`);
        this.filters = "";
        this.newCandidates = [];
        this.updateList = this.updateList.bind(this);
        this.localList = doList ? this.list() : Promise.reject("no list");
        //this.initWS()
        const { newRedactionButton: newRedactionButton, unredactedButton: unredactedButton, redactedButton: redactedButton } = ui.smallMenu;
        newRedactionButton.addEventListener("click", this.redactionBoxEditor.newBox);
        window.addEventListener("keypress", (ev)=>{
            if (ev.key === "n" || ev.key === "N") this.redactionBoxEditor.newBox();
            if (ev.key === "v" || ev.key === "V") {
                this.redactionBoxEditor.toggleUnredacted();
                this.redactionBoxEditor.draw();
                if (this.redactionBoxEditor.isShowingUnredacted()) {
                    unredactedButton.classList.add("hidden");
                    redactedButton.classList.remove("hidden");
                } else {
                    unredactedButton.classList.remove("hidden");
                    redactedButton.classList.add("hidden");
                }
            }
        });
        unredactedButton.addEventListener("click", ()=>{
            switch(this.currentJob){
                case "f":
                    this.templatedDocEditor.embedPdf.style.display = "none";
                    break;
                default:
                    this.redactionBoxEditor.toggleUnredacted();
                    this.redactionBoxEditor.draw();
            }
            unredactedButton.classList.add("hidden");
            redactedButton.classList.remove("hidden");
        });
        redactedButton.addEventListener("click", ()=>{
            switch(this.currentJob){
                case "f":
                    this.templatedDocEditor.embedPdf.style.display = "block";
                    break;
                default:
                    this.redactionBoxEditor.toggleUnredacted();
                    this.redactionBoxEditor.draw();
            }
            unredactedButton.classList.remove("hidden");
            redactedButton.classList.add("hidden");
        });
        ui.toolbar.submitButton.addEventListener("click", ()=>{
            if (!this.currentJob) return;
            switch(this.currentJob){
                case "a":
                    this.redactionBoxEditor.submit();
                    break;
                case "f":
                    this.templatedDocEditor.save();
                    break;
                default:
                    throw new Error("invalid currentJob");
            }
        });
        ui.toolbar.newCandidatesButton.addEventListener("click", ()=>this.handleNewCandidatesClick());
        ui.documents.refreshButton.addEventListener("click", ()=>this.refreshList(this.filters));
    }
    async handleNewCandidatesClick() {
        // @ts-ignore
        this.newCandidatesButton.classList.add("hidden");
        // Get the current list
        const list = await this.localList;
        // -- From now until the copying completes, there's no await, so no sync issues --
        const candidates = list.Candidates;
        console.log(candidates, " old");
        for (const candidate of this.newCandidates){
            console.log(candidate);
            candidates.push(candidate);
        }
        this.newCandidates = [];
        console.log(candidates, " new");
        // -- Copying done, now we can do async again --
        this.updateList(this.filters);
    }
    // public initWS(){
    //   // When a WS connection is opened, send our current timestamp
    //   this.webSocket.onopen = async () => {
    //     this.webSocket.send(JSON.stringify({
    //       "MessageType": "timestamp",
    //       "data": (await this.localList).Timestamp,
    //    }));
    //   };
    //   // When we receive new candidates, store them and show the "New candidates" button
    //   this.webSocket.onmessage = (event) => {
    //     let data = JSON.parse(event.data);
    //     console.log("Data Received", data);
    //     this.newCandidates.push(data);
    //     this.dataReceived();
    //   };
    //   this.webSocket.onerror = (errorEvent) => {
    //     console.error('WebSocket error:', errorEvent);
    //     this.connectionClosed();
    //   };
    //   this.webSocket.onclose = (closeEvent) => {
    //     console.log('WebSocket connection closed:', closeEvent.code, closeEvent.reason);
    //     this.connectionClosed();
    //   };
    // }
    connectionClosed() {
        this.ui.documents.refreshButton.classList.remove("hidden");
    }
    dataReceived() {
        if (this.newCandidates.length) this.ui.toolbar.newCandidatesButton.classList.remove("hidden");
    }
    async updateList(filters) {
        // Create our own filters object, that's just for this call.
        filters = structuredClone(filters);
        // If it's equal to the existing filters, don't do anything.
        if ($28f61b992d9efbdc$var$recordsEqual(filters, this.filters)) return;
        // Otherwise, set the current filter object to ours.
        this.filters = filters;
        // We then wait for the local list, and for a 150ms timeout.
        const [list, _] = await Promise.all([
            this.localList,
            $28f61b992d9efbdc$var$sleep(150)
        ]);
        // After this duration, if the filters object isn't ours, we don't do anything.
        // This prevents a list update for every keypress...
        // Now it's only 150ms after the latest keypress!
        if (this.filters !== filters) return;
        const { recentDocsContainer: recentDocsContainer } = this.ui.documents;
        if (recentDocsContainer && list.Candidates) {
            const listElement = this.createListElement(list.Candidates, filters);
            // Replace all the old children with our single new list
            for (const child of recentDocsContainer.children)recentDocsContainer.removeChild(child);
            recentDocsContainer.appendChild(listElement);
        }
    }
    refreshList(filters) {
        this.localList = this.refresh();
        return this.updateList(filters);
    }
    async list() {
        const response = await this.authFetch("/list");
        if (!response.ok) throw new Error("Non-200 status");
        return await response.json();
    }
    async refresh() {
        const response = await this.authFetch("/refresh");
        if (!response.ok) throw new Error("Non-200 status");
        return await response.json();
    }
    createListElement(candidates, filters) {
        const ul = document.createElement("ul");
        console.log(candidates);
        console.log("Scoring...");
        candidates.forEach((candidate)=>{
            candidate.CandidateName = candidate.FirstName + " " + candidate.LastName;
            candidate.score = Object.entries(filters).filter(([_, value])=>value)// @ts-ignore
            .map(([field, value])=>$dfbca3f0ad245625$exports.single(value, candidate[field])).map((score)=>score === null ? -1000 : score.score).reduce((a, b)=>a + b, 0);
        });
        console.log("Scored!");
        let results = [
            ...candidates
        ];
        results.sort((a, b)=>b.score - a.score);
        if (results.length === 0) results = candidates;
        let selected = null;
        let selectedInner = null;
        if (filters.CandidateId || filters.JobTitle || filters.CandidateName || filters.JobId) {
            this.ui.documents.resultsHeader.style.display = "block";
            results.forEach((candidate)=>{
                const li = document.createElement("li");
                li.addEventListener("click", ()=>{
                    if (selected) selected.classList.remove("selected");
                    selected = li;
                    selected.classList.add("selected");
                });
                const nameElement = document.createElement("p");
                nameElement.innerText = candidate.FirstName + " " + candidate.LastName;
                const candidateId = document.createElement("h3");
                candidateId.innerText = candidate.CandidateId;
                const jobTitle = document.createElement("p");
                jobTitle.innerText = candidate.JobTitle;
                const jobId = document.createElement("h3");
                jobId.innerText = candidate.JobId;
                const documentList = document.createElement("ul");
                //li.append(nameElement, candidateId, jobTitle, jobId, documentList);
                jobId.style.paddingTop = "0.75em";
                li.append(candidateId, nameElement, jobId, jobTitle, documentList);
                ul.appendChild(li);
                for(const idx in candidate.DocumentTypes)for (const job of candidate.DocumentJobs[idx]){
                    let jobName;
                    switch(job){
                        case "a":
                            jobName = "Anonymised";
                            break;
                        case "f":
                            jobName = "Templated";
                            break;
                        default:
                            continue;
                    }
                    const li = document.createElement("li");
                    // @ts-ignore
                    let text = this.DocumentType[candidate.DocumentTypes[idx].toString()];
                    li.innerText = text + " - " + jobName;
                    const paperclip = document.createElement("img");
                    paperclip.src = "paperclip.svg";
                    li.insertBefore(paperclip, li.firstChild);
                    li.addEventListener("click", (_)=>{
                        if (selectedInner) selectedInner.classList.remove("selected");
                        selectedInner = li;
                        selectedInner.classList.add("selected");
                        this.selectCandidate(candidate, Number(idx), job);
                    });
                    documentList.appendChild(li);
                }
            });
        } else this.ui.documents.resultsHeader.style.display = "none";
        return ul;
    }
    async selectCandidate(candidate, documentIdx, job, showButtons = true) {
        const { newRedactionButton: newRedactionButton, unredactedButton: unredactedButton, redactedButton: redactedButton } = this.ui.smallMenu;
        this.currentJob = job;
        switch(job){
            case "a":
                this.templatedDocEditor.setVisibility(false);
                this.redactionBoxEditor.setVisiblity(true);
                await this.redactionBoxEditor.loadDocument(candidate.GroupId, candidate.DocumentIds[documentIdx]);
                if (showButtons) {
                    if (this.redactionBoxEditor.isShowingUnredacted()) {
                        unredactedButton?.classList.add("hidden");
                        redactedButton?.classList.remove("hidden");
                    } else {
                        unredactedButton?.classList.remove("hidden");
                        redactedButton?.classList.add("hidden");
                    }
                    this.ui.toolbar.submitButton.classList.remove("hidden");
                    newRedactionButton?.classList.remove("hidden");
                }
                break;
            case "f":
                this.fetchAndEditTemplatedDoc(candidate.GroupId, candidate.DocumentIds[documentIdx]);
                if (showButtons) {
                    this.templatedDocEditor.embedPdf.style.display = "none";
                    unredactedButton?.classList.add("hidden");
                    redactedButton?.classList.remove("hidden");
                    this.ui.toolbar.submitButton.classList.remove("hidden");
                    newRedactionButton?.classList.add("hidden");
                }
                break;
            default:
                throw new Error("unknown job type");
        }
    }
    /**
     * Select the candidate if exactly one candidate matches the job+candidate ID pair, and the correct document type.
     *
     * Returns a boolean indicating if a candidate was selected.
     */ async autoselect(jobId, candidateId, documentType, job, showButtons = true) {
        const candidates = (await this.localList).Candidates.filter((candidate)=>candidate.JobId === jobId && candidate.CandidateId === candidateId);
        if (candidates.length === 1) {
            const candidate = candidates[0];
            const documentIdx = candidate.DocumentTypes.findIndex((docType)=>docType.toString() === documentType.toString());
            if (documentIdx >= 0) {
                this.selectCandidate(candidates[0], documentIdx, job, showButtons);
                return true;
            }
        }
        return false;
    }
    /**
     * Load a document from the single-access token.
     */ async singleAccess(docId, showButtons = true) {
        const resp = await this.authFetch("/single-access", {
            method: "POST",
            body: ""
        });
        if (!resp.ok) {
            alert("document unavailable");
            throw new Error("single-access response not ok");
        }
        const candidate = await resp.json();
        let documentIdx = 0;
        if (docId) {
            documentIdx = candidate.DocumentIds.indexOf(docId);
            if (documentIdx < 0) {
                alert("document not found");
                return;
            }
        }
        // TODO: Don't just select "a" (anonymisation), actually select the correct editor type.
        this.selectCandidate(candidate, 0, "a", showButtons);
    }
    async fetchAndEditTemplatedDoc(groupId, docId) {
        this.redactionBoxEditor.setVisiblity(false);
        await this.templatedDocEditor.fetchAndEdit(groupId, docId);
        this.templatedDocEditor.setVisibility(true);
    }
    editTemplatedDoc(doc) {
        this.templatedDocEditor.edit(doc);
        this.redactionBoxEditor.setVisiblity(false);
        this.templatedDocEditor.setVisibility(true);
    }
}


const $92acd710bd9304c3$var$ui = {
    main: document.querySelector("main"),
    display: document.getElementById("display"),
    templatingDisplay: document.getElementById("templating-display"),
    pdfDisplay: document.getElementById("embed-pdf"),
    documents: {
        div: document.getElementById("recent-docs"),
        refreshButton: document.getElementById("refresh-button"),
        resultsHeader: document.getElementById("results-header"),
        recentDocsContainer: document.getElementById("recent-docs-container")
    },
    smallMenu: {
        div: document.getElementById("small-menu"),
        closeMenuButton: document.getElementById("close-menu-button"),
        openMenuButton: document.getElementById("open-menu-button"),
        newRedactionButton: document.getElementById("new-redaction"),
        unredactedButton: document.getElementById("unredacted-button"),
        redactedButton: document.getElementById("redacted-button")
    },
    toolbar: {
        div: document.getElementById("toolbar"),
        submitButton: document.getElementById("submit-button"),
        newCandidatesButton: document.getElementById("new-candidates")
    }
};
const $92acd710bd9304c3$var$filters = {
    CandidateId: "",
    JobTitle: "",
    CandidateName: "",
    JobId: ""
};
function $92acd710bd9304c3$var$sleep(duration) {
    return new Promise((resolve)=>setTimeout(()=>resolve(), duration));
}
async function $92acd710bd9304c3$var$hidePageQuick() {
    $92acd710bd9304c3$var$ui.main.classList.add("hidden");
}
async function $92acd710bd9304c3$var$showPage() {
    $92acd710bd9304c3$var$ui.main.classList.remove("hidden");
    $92acd710bd9304c3$var$ui.main.classList.remove("hidden-smooth");
}
/**
 * Hide the sidebar.
 *
 * @param hard - if true, the button to show the sidebar again is removed
 */ async function $92acd710bd9304c3$var$hideSidebar(hard = false) {
    $92acd710bd9304c3$var$ui.main.classList.add("hidden-smooth");
    $92acd710bd9304c3$var$ui.smallMenu.div.classList.add("hidden-smooth");
    await $92acd710bd9304c3$var$sleep(320);
    $92acd710bd9304c3$var$ui.main.style.paddingLeft = "50px";
    $92acd710bd9304c3$var$ui.main.style.paddingRight = "50px";
    $92acd710bd9304c3$var$ui.smallMenu.closeMenuButton.classList.add("hidden");
    $92acd710bd9304c3$var$ui.documents.div.classList.add("hidden");
    $92acd710bd9304c3$var$ui.main.classList.remove("hidden");
    $92acd710bd9304c3$var$ui.main.classList.remove("hidden-smooth");
    if (hard) $92acd710bd9304c3$var$ui.smallMenu.openMenuButton.classList.add("hidden");
    else $92acd710bd9304c3$var$ui.smallMenu.openMenuButton.classList.remove("hidden");
    $92acd710bd9304c3$var$ui.smallMenu.div.classList.remove("hidden-smooth");
}
async function $92acd710bd9304c3$var$openSidebar() {
    $92acd710bd9304c3$var$ui.main.classList.add("hidden-smooth");
    $92acd710bd9304c3$var$ui.smallMenu.div.classList.add("hidden-smooth");
    await $92acd710bd9304c3$var$sleep(320);
    $92acd710bd9304c3$var$ui.main.style.paddingLeft = "unset";
    $92acd710bd9304c3$var$ui.main.style.paddingRight = "unset";
    $92acd710bd9304c3$var$ui.smallMenu.openMenuButton.classList.add("hidden");
    $92acd710bd9304c3$var$ui.documents.div.classList.remove("hidden");
    $92acd710bd9304c3$var$ui.main.classList.remove("hidden");
    $92acd710bd9304c3$var$ui.main.classList.remove("hidden-smooth");
    $92acd710bd9304c3$var$ui.smallMenu.closeMenuButton.classList.remove("hidden");
    $92acd710bd9304c3$var$ui.smallMenu.div.classList.remove("hidden-smooth");
}
$92acd710bd9304c3$var$ui.smallMenu.closeMenuButton.addEventListener("click", ()=>$92acd710bd9304c3$var$hideSidebar());
$92acd710bd9304c3$var$ui.smallMenu.openMenuButton.addEventListener("click", $92acd710bd9304c3$var$openSidebar);
function $92acd710bd9304c3$var$closeOverlays() {
    document.getElementById("overlay")?.classList.remove("active");
    document.getElementById("success-popup")?.classList.remove("active");
}
document.querySelectorAll(".close-overlay").forEach((elem)=>elem.addEventListener("click", $92acd710bd9304c3$var$closeOverlays));
function $92acd710bd9304c3$export$b0939f2e76a1d855() {
    document.getElementById("overlay")?.classList.add("active");
}
function $92acd710bd9304c3$export$d841eba85c078f0b() {
    $92acd710bd9304c3$export$b0939f2e76a1d855();
    document.getElementById("success-popup")?.classList.add("active");
}
let $92acd710bd9304c3$var$editor;
function $92acd710bd9304c3$var$filterInputUpdate(ev) {
    const target = ev.target;
    const filter = target.getAttribute("x-filter");
    // @ts-ignore
    $92acd710bd9304c3$var$filters[filter] = target.value;
    $92acd710bd9304c3$var$editor.updateList($92acd710bd9304c3$var$filters);
}
const $92acd710bd9304c3$var$filterInputs = document.querySelectorAll("#filters > input");
$92acd710bd9304c3$var$filterInputs.forEach((elem)=>{
    const input = elem;
    input.addEventListener("change", $92acd710bd9304c3$var$filterInputUpdate);
    input.addEventListener("keypress", $92acd710bd9304c3$var$filterInputUpdate);
    input.addEventListener("keyup", $92acd710bd9304c3$var$filterInputUpdate);
});
/**
 * Convert a string to upper cammel case. For example:
 *
 * alreadyUpperCamel -> AlreadyUpperCamel
 * lowerCammelCase -> LowerCammelCase
 * snake_case -> SnakeCase
 * With some spaces -> WithSomeSpaces
 * Part of LGBTQ -> PartOfLGBTQ
 */ function $92acd710bd9304c3$var$toUpperCammelCase(s) {
    // First, remove surrounding whitespace
    s = s.trim();
    // The output starts with the first character, lower cased
    let output = s[0].toUpperCase();
    // Then we iterate over the remaining characters
    let isFollowingSpace = false;
    for (const ch of s.substring(1))switch(ch){
        case "_":
        case "-":
        case " ":
        case "	":
        case "\r":
        case "\n":
            isFollowingSpace = true;
            break;
        default:
            if (isFollowingSpace) {
                output += ch.toUpperCase();
                isFollowingSpace = false;
            } else output += ch;
    }
    return output;
}
function $92acd710bd9304c3$var$testToUpperCammelCase() {
    // alreadyUpperCamel -> alreadyUpperCamel
    console.assert($92acd710bd9304c3$var$toUpperCammelCase("AlreadyUpperCamel") === "AlreadyUpperCamel");
    // UpperCammelCase -> upperCammelCase
    console.assert($92acd710bd9304c3$var$toUpperCammelCase("lowerCammelCase") === "LowerCammelCase");
    // snake_case -> snakeCase
    console.assert($92acd710bd9304c3$var$toUpperCammelCase("snake_case") === "SnakeCase");
    // With some spaces -> withSomeSpaces
    console.assert($92acd710bd9304c3$var$toUpperCammelCase("With some spaces") === "WithSomeSpaces");
    // Part of LGBTQ -> partOfLGBTQ
    console.assert($92acd710bd9304c3$var$toUpperCammelCase("Part of LGBTQ") === "PartOfLGBTQ");
}
const $92acd710bd9304c3$var$args = (0, $7b267e1bfb29ea44$export$a7fe16ffd34a2ac3)();
if ($92acd710bd9304c3$var$args.sat) {
    // Single-access token flow
    console.log("SAT Active");
    // First, we remove the token from the URL
    history.replaceState(null, "", "?");
    // We then parse the token, which has the form:
    // <store-token-id>.<token:jwt>
    const tokenParts = $92acd710bd9304c3$var$args.sat.split(".");
    const storeTokenId = tokenParts[0];
    const token = tokenParts.slice(1).join(".");
    // We then start the fetch for the store token from simple-store. This is what makes the token
    // single-use. The store will only give us the token from the ID once.
    // Note that we don't await it here!
    const storeTokenPromise = fetch("https://simple-store.mevitae.net/api/get", {
        method: "POST",
        headers: {
            "X-MeVitae-Key": "public-editor-us"
        },
        body: storeTokenId,
        mode: "cors",
        cache: "no-store",
        redirect: "error"
    }).then((resp)=>{
        if (resp.status === 404) alert("Expired token, please use a new link.");
        if (!resp.ok) throw new Error("simple-store response not ok");
        return resp.text();
    }).then((token)=>{
        const successPopup = document.getElementById("success-popup");
        if (successPopup) {
            const { success_message: successMessage, success_button_text: successButtonText, success_button_action: successButtonAction } = JSON.parse(atob(token.split(".")[1].replaceAll("-", "+").replaceAll("_", "/")));
            if (successMessage) {
                const messagePara = successPopup.querySelector("#success-message");
                if (messagePara) messagePara.innerText = successMessage;
                else console.error("success-message element does not exist");
            }
            const button = successPopup.querySelector("button.close-overlay");
            if (button) {
                if (successButtonText) button.innerText = successButtonText;
                if (successButtonAction) {
                    button.removeEventListener("click", $92acd710bd9304c3$var$closeOverlays);
                    button.addEventListener("click", ()=>location.href = successButtonAction);
                }
            } else console.error("success-popup > button does not exist");
        } else console.error("success-popup element does not exist");
        return token;
    });
    /**
     * Make a fetch request, with SAT credentials.
     */ async function satFetch(url, options = {}, retries = 1, timeout = 90000, refresh = true) {
        const storeToken = await storeTokenPromise;
        if (!options) options = {};
        const controller = new AbortController();
        const timeoutId = setTimeout(()=>controller.abort(), timeout);
        options.signal = controller.signal;
        if (!options.headers) options.headers = {};
        // @ts-ignore
        options.headers["X-MeVitae-Store-Token"] = storeToken;
        // @ts-ignore
        options.headers["X-MeVitae-Single-Access-Token"] = token;
        const resp = await fetch(url, options);
        clearTimeout(timeoutId);
        if (resp.status === 401 || resp.status === 403) {
            alert("unauthorized");
            window.location.href = "https://accounts.mevitae.com";
        } else if (!resp.ok && retries > 0) return satFetch(url, options, retries - 1, timeout, refresh);
        return resp;
    }
    $92acd710bd9304c3$var$editor = new (0, $28f61b992d9efbdc$export$7cda8d932e2f33c0)(satFetch, $92acd710bd9304c3$var$ui, false);
    $92acd710bd9304c3$var$hideSidebar(true);
    async function load() {
        await $92acd710bd9304c3$var$editor.singleAccess();
        // If selected, give is 500ms to load before fading in (and time for the hidden buttons to fade out)
        await $92acd710bd9304c3$var$sleep(500);
        $92acd710bd9304c3$var$ui.smallMenu.div.classList.remove("hidden");
        $92acd710bd9304c3$var$showPage();
    }
    load();
} else {
    console.log("No SAT:", $92acd710bd9304c3$var$args);
    // Usual flow, with SSO auth
    $92acd710bd9304c3$var$editor = new (0, $28f61b992d9efbdc$export$7cda8d932e2f33c0)((0, $3aec7978884109a4$export$5256615b306d8eda).fromSession(()=>location.href = "https://accounts.mevitae.com").fetch, $92acd710bd9304c3$var$ui, true);
    // The query parameters are used to set the default filters, and optionally auto-select a
    // document
    for(const key in $92acd710bd9304c3$var$args){
        const filter = $92acd710bd9304c3$var$toUpperCammelCase(key);
        for (const input of $92acd710bd9304c3$var$filterInputs)if (input.getAttribute("x-filter") === filter) {
            const value = $92acd710bd9304c3$var$args[key];
            input.value = value;
            // @ts-ignore
            $92acd710bd9304c3$var$filters[filter] = value;
            break;
        }
    }
    $92acd710bd9304c3$var$editor.updateList($92acd710bd9304c3$var$filters);
    if ($92acd710bd9304c3$var$args.job_id && $92acd710bd9304c3$var$args.candidate_id && $92acd710bd9304c3$var$args.doc_type && !isNaN(Number($92acd710bd9304c3$var$args.doc_type))) {
        $92acd710bd9304c3$var$ui.smallMenu.div.classList.add("hidden-smooth");
        $92acd710bd9304c3$var$ui.smallMenu.div.classList.add("hidden");
        $92acd710bd9304c3$var$editor.autoselect($92acd710bd9304c3$var$args.job_id, $92acd710bd9304c3$var$args.candidate_id, Number($92acd710bd9304c3$var$args.doc_type), $92acd710bd9304c3$var$args.job || "a").then(async (selected)=>{
            // If selected, give is 500ms to load before fading in (and time for the hidden buttons to fade out)
            if (selected) await $92acd710bd9304c3$var$sleep(500);
            $92acd710bd9304c3$var$ui.smallMenu.div.classList.remove("hidden");
            if (selected) $92acd710bd9304c3$var$hideSidebar();
            else $92acd710bd9304c3$var$openSidebar();
        });
    } else $92acd710bd9304c3$var$showPage();
}


//# sourceMappingURL=index.3c5bd3cd.js.map
